/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AssociateCustomerSuccessMeetingDateTimeToPlatformRequest,
  AssociatePracticeTypeToPlatformRequest,
  AssociateSalesforceAccountIdToPlatformRequest,
  AssociateSalesforceIdToPlatformRequest,
  BillingEveryPlatformIntegrityViolation,
  BillingIntegrityFinding,
  CompanyBillingInfo,
  ConfirmOnboardingBrandingForPlatformRequest,
  ConfirmOnboardingBusinessVerificationForPlatformRequest,
  ConfirmOnboardingCatalogUploadForPlatformRequest,
  ConfirmOnboardingPaymentStepForPlatformRequest,
  ConfirmOnboardingUserInformationForPlatformRequest,
  CreateMembershipFromCatalogRequest,
  CreatePackageFromCatalogRequest,
  CreatePlatformRequest,
  CreateSalesAssociateRequest,
  CreateTreatmentFromCatalogRequest,
  DefineExecutiveCancellationReviewRequest,
  DisplayAbbreviatedPlatformSummary,
  DisplayAllowAnonPlatformLinks,
  DisplayAllowAnonPlatformProductSubscriptions,
  DisplayBasicSmartSiteLaunchConfigurationResponse,
  DisplayBrandIconState,
  DisplayCallerIdVerificationInitiatedForPlatformLocation,
  DisplayCallerIdVerificationInitiationReference,
  DisplayCallerIdVerificationStatusForPlatformLocation,
  DisplayCancellationCallOffer,
  DisplayCancellationContext,
  DisplayCompanyKybAccountsResponse,
  DisplayCompanyKybVerificationStatusForPlatform,
  DisplayCompanyVerificationInformation,
  DisplayCompanyVerificationProcess,
  DisplayCreatedPlatformResponse,
  DisplayDisputeDetails,
  DisplayDisputesForPlatform,
  DisplayExecutiveCancellationReviews,
  DisplayExtractedPlatformBranding,
  DisplayInitiatedMembershipCatalogImportResponse,
  DisplayInitiatedPackageCatalogImportResponse,
  DisplayOperatingHoursForPlatformLocation,
  DisplayPagedPlatformSummariesResponse,
  DisplayPagedPlatformVerificationProcessesResponse,
  DisplayPendingExecutiveCancellationReview,
  DisplayPlatformDomainResponse,
  DisplayPlatformOnboardingProgress,
  DisplayPlatformProductSubscriptions,
  DisplayPlgOnboardingSchedulingDetails,
  DisplayProcessingFeeReconciliationResponse,
  DisplayRepeatCashBalancesForPlatform,
  DisplayRepeatCashTransactionsForPlatform,
  DisplayRetailProductsMarketplaceVisibilitySchedule,
  DisplaySalesAssociateResponse,
  DisplaySkinDropMarketplaceVisibilitySchedule,
  DisplayVerifiedCallerIdsForPlatform,
  ExtractPlatformBrandingRequest,
  GetPagedPlatformSummariesParams,
  GetPagedPlatformVerificationProcessesParams,
  GetPlatformDomainsParams,
  GetPlatformPayoutsStatsResult,
  GetPlatformTransactionsStatsResult,
  InitiateCallerIdVerificationForPlatformLocationRequest,
  InitiatePracticeCatalogDataImportBody,
  LatestPracticeCatalogDataImportRetrievedResponse,
  PlatformLocationsTimezonesResult,
  PlatformModel,
  PlatformPricingTierModel,
  PlatformSettingsUpdatedEvent,
  PlatformSwitchedToStripeRegionEvent,
  PlatformsRetrieveBillingIntegrityFindingsParams,
  PracticeCatalogDataImportPreview,
  PracticeCatalogDataImportStatus,
  PracticeTypeAssociatedToPlatformEvent,
  ProblemDetails,
  RegenerateBrandIconsForPlatformRequest,
  RegeneratePlatformShortLinksParams,
  RequestCustomDomainForPlatformRequest,
  RetrieveBillingEveryPlatformIntegrityViolationsParams,
  RetrievePlatformProcessingFeeReconciliationParams,
  SalesforceAccountIdAssociatedToPlatformEvent,
  SalesforceIdAssociatedToPlatformEvent,
  ScheduleRetailProductsVisibilityOnMarketplaceRequest,
  ScheduleSkinDropVisibilityOnMarketplaceRequest,
  SetAgelessOpportunityForPlatformRequest,
  SetBrandingForAppPlatformLocationRequest,
  SetCompanyKybVerificationStatusForPlatformRequest,
  SetDataPrivacyRegionForPlatformRequest,
  SetExecutiveCancellationReviewMeetingRequest,
  SetExecutiveCancellationReviewOutcomeRequest,
  SetHeroContentForAppPlatformLocationRequest,
  SetLogoDisplayForAppPlatformRequest,
  SetLogoImageForAppPlatformLocationRequest,
  SetOperatingHoursForPlatformLocationRequest,
  SetRepeatMdOpportunityForPlatformRequest,
  SetSalesforceParentAccountIdForPlatformRequest,
  SubmitCancellationRatingsRequest,
  SubmitCancellationRequest,
  SubmitCancellationSupportRequestRequest,
  UpdatePlatformDomainRequest,
  UpdatePlatformFeeConfigurationRequest,
  UpdatePlatformLocationRequest,
  UpdatePlatformRequest,
  UpdatePlatformSettingsRequest,
  UpdatePlatformTipSettingsRequest,
  UpdateSalesAssociateRequest
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Returns operational platform product subscriptions for the specified platform.
Anonymous-safe: operational product list only (no customer-history or billing signals).
 */
export const getAllowAnonProductSubscriptionsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAllowAnonPlatformProductSubscriptions>(
      {url: `/api/v1/platforms/${platformId}/product-subscriptions`, method: 'GET', signal
    },
      );
    }




export const getGetAllowAnonProductSubscriptionsForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/product-subscriptions`
    ] as const;
    }


export const getGetAllowAnonProductSubscriptionsForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllowAnonProductSubscriptionsForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>> = ({ signal }) => getAllowAnonProductSubscriptionsForPlatform(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllowAnonProductSubscriptionsForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>>
export type GetAllowAnonProductSubscriptionsForPlatformQueryError = ErrorType<unknown>


export function useGetAllowAnonProductSubscriptionsForPlatform<TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllowAnonProductSubscriptionsForPlatform<TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllowAnonProductSubscriptionsForPlatform<TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns operational platform product subscriptions for the specified platform.
Anonymous-safe: operational product list only (no customer-history or billing signals).
 */

export function useGetAllowAnonProductSubscriptionsForPlatform<TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllowAnonProductSubscriptionsForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAllowAnonProductSubscriptionsForPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllowAnonProductSubscriptionsForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>> = ({ signal }) => getAllowAnonProductSubscriptionsForPlatform(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAllowAnonProductSubscriptionsForPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>>
export type GetAllowAnonProductSubscriptionsForPlatformSuspenseQueryError = ErrorType<unknown>


export function useGetAllowAnonProductSubscriptionsForPlatformSuspense<TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllowAnonProductSubscriptionsForPlatformSuspense<TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllowAnonProductSubscriptionsForPlatformSuspense<TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns operational platform product subscriptions for the specified platform.
Anonymous-safe: operational product list only (no customer-history or billing signals).
 */

export function useGetAllowAnonProductSubscriptionsForPlatformSuspense<TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllowAnonProductSubscriptionsForPlatformSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns shareable platform links for the specified platform.
Anonymous-safe: app, shortcut, and check-in URLs, public brand color/tint, public brand asset URLs
(logo, favicon, mobile app icons — already served anonymously by the tenant-host platform endpoints),
and the signup offer disclaimer only.
 */
export const getAllowAnonLinksForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAllowAnonPlatformLinks>(
      {url: `/api/v1/platforms/${platformId}/links`, method: 'GET', signal
    },
      );
    }




export const getGetAllowAnonLinksForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/links`
    ] as const;
    }


export const getGetAllowAnonLinksForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllowAnonLinksForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>> = ({ signal }) => getAllowAnonLinksForPlatform(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllowAnonLinksForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>>
export type GetAllowAnonLinksForPlatformQueryError = ErrorType<ProblemDetails>


export function useGetAllowAnonLinksForPlatform<TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllowAnonLinksForPlatform<TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllowAnonLinksForPlatform<TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns shareable platform links for the specified platform.
Anonymous-safe: app, shortcut, and check-in URLs, public brand color/tint, public brand asset URLs
(logo, favicon, mobile app icons — already served anonymously by the tenant-host platform endpoints),
and the signup offer disclaimer only.
 */

export function useGetAllowAnonLinksForPlatform<TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllowAnonLinksForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAllowAnonLinksForPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllowAnonLinksForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>> = ({ signal }) => getAllowAnonLinksForPlatform(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAllowAnonLinksForPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>>
export type GetAllowAnonLinksForPlatformSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetAllowAnonLinksForPlatformSuspense<TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllowAnonLinksForPlatformSuspense<TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllowAnonLinksForPlatformSuspense<TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns shareable platform links for the specified platform.
Anonymous-safe: app, shortcut, and check-in URLs, public brand color/tint, public brand asset URLs
(logo, favicon, mobile app icons — already served anonymously by the tenant-host platform endpoints),
and the signup offer disclaimer only.
 */

export function useGetAllowAnonLinksForPlatformSuspense<TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllowAnonLinksForPlatformSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Sets the platform-wide display preference for location logos.
 */
export const setLogoDisplayForAppPlatform = (
    platformId: string,
    setLogoDisplayForAppPlatformRequest: SetLogoDisplayForAppPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/logo-display`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setLogoDisplayForAppPlatformRequest, signal
    },
      );
    }




export const getSetLogoDisplayForAppPlatformMutationKey = () => ['setLogoDisplayForAppPlatform'] as const;

export const getSetLogoDisplayForAppPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLogoDisplayForAppPlatform>>, TError,SetLogoDisplayForAppPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLogoDisplayForAppPlatform>>, TError,SetLogoDisplayForAppPlatformMutationVariables, TContext> => {

const mutationKey = getSetLogoDisplayForAppPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLogoDisplayForAppPlatform>>, SetLogoDisplayForAppPlatformMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  setLogoDisplayForAppPlatform(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLogoDisplayForAppPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof setLogoDisplayForAppPlatform>>>
    export type SetLogoDisplayForAppPlatformMutationBody = SetLogoDisplayForAppPlatformRequest
    export type SetLogoDisplayForAppPlatformMutationError = ErrorType<unknown>
    export type SetLogoDisplayForAppPlatformMutationVariables = {platformId: string;data: SetLogoDisplayForAppPlatformRequest}

    /**
 * @summary Sets the platform-wide display preference for location logos.
 */
export const useSetLogoDisplayForAppPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLogoDisplayForAppPlatform>>, TError,SetLogoDisplayForAppPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLogoDisplayForAppPlatform>>,
        TError,
        SetLogoDisplayForAppPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getSetLogoDisplayForAppPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Sets or removes an optional logo for a location of a multi-location platform.
 */
export const setLogoImageForAppPlatformLocation = (
    platformId: string,
    locationId: string,
    setLogoImageForAppPlatformLocationRequest: SetLogoImageForAppPlatformLocationRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/logo`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setLogoImageForAppPlatformLocationRequest, signal
    },
      );
    }




export const getSetLogoImageForAppPlatformLocationMutationKey = () => ['setLogoImageForAppPlatformLocation'] as const;

export const getSetLogoImageForAppPlatformLocationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLogoImageForAppPlatformLocation>>, TError,SetLogoImageForAppPlatformLocationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLogoImageForAppPlatformLocation>>, TError,SetLogoImageForAppPlatformLocationMutationVariables, TContext> => {

const mutationKey = getSetLogoImageForAppPlatformLocationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLogoImageForAppPlatformLocation>>, SetLogoImageForAppPlatformLocationMutationVariables> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setLogoImageForAppPlatformLocation(platformId,locationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLogoImageForAppPlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof setLogoImageForAppPlatformLocation>>>
    export type SetLogoImageForAppPlatformLocationMutationBody = SetLogoImageForAppPlatformLocationRequest
    export type SetLogoImageForAppPlatformLocationMutationError = ErrorType<unknown>
    export type SetLogoImageForAppPlatformLocationMutationVariables = {platformId: string;locationId: string;data: SetLogoImageForAppPlatformLocationRequest}

    /**
 * @summary Sets or removes an optional logo for a location of a multi-location platform.
 */
export const useSetLogoImageForAppPlatformLocation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLogoImageForAppPlatformLocation>>, TError,SetLogoImageForAppPlatformLocationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLogoImageForAppPlatformLocation>>,
        TError,
        SetLogoImageForAppPlatformLocationMutationVariables,
        TContext
      > => {
      return useMutation(getSetLogoImageForAppPlatformLocationMutationOptions(options), queryClient);
    }
    /**
 * @summary Sets or removes the storefront hero content overrides for a platform location.
 */
export const setHeroContentForAppPlatformLocation = (
    platformId: string,
    locationId: string,
    setHeroContentForAppPlatformLocationRequest: SetHeroContentForAppPlatformLocationRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/hero-content`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setHeroContentForAppPlatformLocationRequest, signal
    },
      );
    }




export const getSetHeroContentForAppPlatformLocationMutationKey = () => ['setHeroContentForAppPlatformLocation'] as const;

export const getSetHeroContentForAppPlatformLocationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setHeroContentForAppPlatformLocation>>, TError,SetHeroContentForAppPlatformLocationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setHeroContentForAppPlatformLocation>>, TError,SetHeroContentForAppPlatformLocationMutationVariables, TContext> => {

const mutationKey = getSetHeroContentForAppPlatformLocationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setHeroContentForAppPlatformLocation>>, SetHeroContentForAppPlatformLocationMutationVariables> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setHeroContentForAppPlatformLocation(platformId,locationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetHeroContentForAppPlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof setHeroContentForAppPlatformLocation>>>
    export type SetHeroContentForAppPlatformLocationMutationBody = SetHeroContentForAppPlatformLocationRequest
    export type SetHeroContentForAppPlatformLocationMutationError = ErrorType<unknown>
    export type SetHeroContentForAppPlatformLocationMutationVariables = {platformId: string;locationId: string;data: SetHeroContentForAppPlatformLocationRequest}

    /**
 * @summary Sets or removes the storefront hero content overrides for a platform location.
 */
export const useSetHeroContentForAppPlatformLocation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setHeroContentForAppPlatformLocation>>, TError,SetHeroContentForAppPlatformLocationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setHeroContentForAppPlatformLocation>>,
        TError,
        SetHeroContentForAppPlatformLocationMutationVariables,
        TContext
      > => {
      return useMutation(getSetHeroContentForAppPlatformLocationMutationOptions(options), queryClient);
    }
    /**
 * @summary Sets location logo display and an optional brand color override.
 */
export const setBrandingForAppPlatformLocation = (
    platformId: string,
    locationId: string,
    setBrandingForAppPlatformLocationRequest: SetBrandingForAppPlatformLocationRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/branding`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setBrandingForAppPlatformLocationRequest, signal
    },
      );
    }




export const getSetBrandingForAppPlatformLocationMutationKey = () => ['setBrandingForAppPlatformLocation'] as const;

export const getSetBrandingForAppPlatformLocationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBrandingForAppPlatformLocation>>, TError,SetBrandingForAppPlatformLocationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setBrandingForAppPlatformLocation>>, TError,SetBrandingForAppPlatformLocationMutationVariables, TContext> => {

const mutationKey = getSetBrandingForAppPlatformLocationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setBrandingForAppPlatformLocation>>, SetBrandingForAppPlatformLocationMutationVariables> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setBrandingForAppPlatformLocation(platformId,locationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetBrandingForAppPlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof setBrandingForAppPlatformLocation>>>
    export type SetBrandingForAppPlatformLocationMutationBody = SetBrandingForAppPlatformLocationRequest
    export type SetBrandingForAppPlatformLocationMutationError = ErrorType<unknown>
    export type SetBrandingForAppPlatformLocationMutationVariables = {platformId: string;locationId: string;data: SetBrandingForAppPlatformLocationRequest}

    /**
 * @summary Sets location logo display and an optional brand color override.
 */
export const useSetBrandingForAppPlatformLocation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBrandingForAppPlatformLocation>>, TError,SetBrandingForAppPlatformLocationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setBrandingForAppPlatformLocation>>,
        TError,
        SetBrandingForAppPlatformLocationMutationVariables,
        TContext
      > => {
      return useMutation(getSetBrandingForAppPlatformLocationMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves live violations for whether every active CoreServices platform is being billed.
 */
export const retrieveBillingEveryPlatformIntegrityViolations = (
    params: RetrieveBillingEveryPlatformIntegrityViolationsParams,
 signal?: AbortSignal
) => {


      return customAxios<BillingEveryPlatformIntegrityViolation[]>(
      {url: `/api/v1/platforms/billing-reconciliation/questions/billing-every-platform`, method: 'GET',
        params, signal
    },
      );
    }




export const getRetrieveBillingEveryPlatformIntegrityViolationsQueryKey = (params?: RetrieveBillingEveryPlatformIntegrityViolationsParams,) => {
    return [
    `/api/v1/platforms/billing-reconciliation/questions/billing-every-platform`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrieveBillingEveryPlatformIntegrityViolationsQueryOptions = <TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveBillingEveryPlatformIntegrityViolationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>> = ({ signal }) => retrieveBillingEveryPlatformIntegrityViolations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RetrieveBillingEveryPlatformIntegrityViolationsQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>>
export type RetrieveBillingEveryPlatformIntegrityViolationsQueryError = ErrorType<ProblemDetails>


export function useRetrieveBillingEveryPlatformIntegrityViolations<TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(
 params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>,
          TError,
          Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveBillingEveryPlatformIntegrityViolations<TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(
 params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>,
          TError,
          Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveBillingEveryPlatformIntegrityViolations<TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(
 params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves live violations for whether every active CoreServices platform is being billed.
 */

export function useRetrieveBillingEveryPlatformIntegrityViolations<TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(
 params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetrieveBillingEveryPlatformIntegrityViolationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRetrieveBillingEveryPlatformIntegrityViolationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveBillingEveryPlatformIntegrityViolationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>> = ({ signal }) => retrieveBillingEveryPlatformIntegrityViolations(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type RetrieveBillingEveryPlatformIntegrityViolationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>>
export type RetrieveBillingEveryPlatformIntegrityViolationsSuspenseQueryError = ErrorType<ProblemDetails>


export function useRetrieveBillingEveryPlatformIntegrityViolationsSuspense<TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(
 params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveBillingEveryPlatformIntegrityViolationsSuspense<TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(
 params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveBillingEveryPlatformIntegrityViolationsSuspense<TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(
 params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves live violations for whether every active CoreServices platform is being billed.
 */

export function useRetrieveBillingEveryPlatformIntegrityViolationsSuspense<TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(
 params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetrieveBillingEveryPlatformIntegrityViolationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves billing integrity findings for the selected UTC reconciliation date.
 */
export const platformsRetrieveBillingIntegrityFindings = (
    params: PlatformsRetrieveBillingIntegrityFindingsParams,
 signal?: AbortSignal
) => {


      return customAxios<BillingIntegrityFinding[]>(
      {url: `/api/v1/platforms/billing-reconciliation/findings`, method: 'GET',
        params, signal
    },
      );
    }




export const getPlatformsRetrieveBillingIntegrityFindingsQueryKey = (params?: PlatformsRetrieveBillingIntegrityFindingsParams,) => {
    return [
    `/api/v1/platforms/billing-reconciliation/findings`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformsRetrieveBillingIntegrityFindingsQueryOptions = <TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(params: PlatformsRetrieveBillingIntegrityFindingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsRetrieveBillingIntegrityFindingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>> = ({ signal }) => platformsRetrieveBillingIntegrityFindings(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformsRetrieveBillingIntegrityFindingsQueryResult = NonNullable<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>>
export type PlatformsRetrieveBillingIntegrityFindingsQueryError = ErrorType<unknown>


export function usePlatformsRetrieveBillingIntegrityFindings<TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(
 params: PlatformsRetrieveBillingIntegrityFindingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>,
          TError,
          Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsRetrieveBillingIntegrityFindings<TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(
 params: PlatformsRetrieveBillingIntegrityFindingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>,
          TError,
          Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsRetrieveBillingIntegrityFindings<TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(
 params: PlatformsRetrieveBillingIntegrityFindingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves billing integrity findings for the selected UTC reconciliation date.
 */

export function usePlatformsRetrieveBillingIntegrityFindings<TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(
 params: PlatformsRetrieveBillingIntegrityFindingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformsRetrieveBillingIntegrityFindingsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformsRetrieveBillingIntegrityFindingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(params: PlatformsRetrieveBillingIntegrityFindingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsRetrieveBillingIntegrityFindingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>> = ({ signal }) => platformsRetrieveBillingIntegrityFindings(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type PlatformsRetrieveBillingIntegrityFindingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>>
export type PlatformsRetrieveBillingIntegrityFindingsSuspenseQueryError = ErrorType<unknown>


export function usePlatformsRetrieveBillingIntegrityFindingsSuspense<TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(
 params: PlatformsRetrieveBillingIntegrityFindingsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsRetrieveBillingIntegrityFindingsSuspense<TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(
 params: PlatformsRetrieveBillingIntegrityFindingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsRetrieveBillingIntegrityFindingsSuspense<TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(
 params: PlatformsRetrieveBillingIntegrityFindingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves billing integrity findings for the selected UTC reconciliation date.
 */

export function usePlatformsRetrieveBillingIntegrityFindingsSuspense<TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(
 params: PlatformsRetrieveBillingIntegrityFindingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformsRetrieveBillingIntegrityFindingsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Creates a new Platform.
 */
export const createPlatform = (
    createPlatformRequest: CreatePlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCreatedPlatformResponse>(
      {url: `/api/v1/platforms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPlatformRequest, signal
    },
      );
    }




export const getCreatePlatformMutationKey = () => ['createPlatform'] as const;

export const getCreatePlatformMutationOptions = <TError = ErrorType<void | ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlatform>>, TError,CreatePlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPlatform>>, TError,CreatePlatformMutationVariables, TContext> => {

const mutationKey = getCreatePlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlatform>>, CreatePlatformMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPlatform(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePlatformMutationResult = NonNullable<Awaited<ReturnType<typeof createPlatform>>>
    export type CreatePlatformMutationBody = CreatePlatformRequest
    export type CreatePlatformMutationError = ErrorType<void | ProblemDetails>
    export type CreatePlatformMutationVariables = {data: CreatePlatformRequest}

    /**
 * @summary Creates a new Platform.
 */
export const useCreatePlatform = <TError = ErrorType<void | ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlatform>>, TError,CreatePlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPlatform>>,
        TError,
        CreatePlatformMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Gets a list of existing Platforms.
 */
export const platformsGetPlatforms = (

 signal?: AbortSignal
) => {


      return customAxios<PlatformModel[]>(
      {url: `/api/v1/platforms`, method: 'GET', signal
    },
      );
    }




export const getPlatformsGetPlatformsQueryKey = () => {
    return [
    `/api/v1/platforms`
    ] as const;
    }


export const getPlatformsGetPlatformsQueryOptions = <TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsGetPlatformsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsGetPlatforms>>> = ({ signal }) => platformsGetPlatforms(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformsGetPlatformsQueryResult = NonNullable<Awaited<ReturnType<typeof platformsGetPlatforms>>>
export type PlatformsGetPlatformsQueryError = ErrorType<unknown>


export function usePlatformsGetPlatforms<TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformsGetPlatforms>>,
          TError,
          Awaited<ReturnType<typeof platformsGetPlatforms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatforms<TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformsGetPlatforms>>,
          TError,
          Awaited<ReturnType<typeof platformsGetPlatforms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatforms<TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets a list of existing Platforms.
 */

export function usePlatformsGetPlatforms<TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformsGetPlatformsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformsGetPlatformsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsGetPlatformsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsGetPlatforms>>> = ({ signal }) => platformsGetPlatforms(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type PlatformsGetPlatformsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformsGetPlatforms>>>
export type PlatformsGetPlatformsSuspenseQueryError = ErrorType<unknown>


export function usePlatformsGetPlatformsSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatformsSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatformsSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets a list of existing Platforms.
 */

export function usePlatformsGetPlatformsSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformsGetPlatformsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets a lightweight list of platform dropdown options for the platform selector.
 */
export const getPlatformsDropdownOptions = (

 signal?: AbortSignal
) => {


      return customAxios<DisplayAbbreviatedPlatformSummary[]>(
      {url: `/api/v1/platforms/dropdown-options`, method: 'GET', signal
    },
      );
    }




export const getGetPlatformsDropdownOptionsQueryKey = () => {
    return [
    `/api/v1/platforms/dropdown-options`
    ] as const;
    }


export const getGetPlatformsDropdownOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformsDropdownOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>> = ({ signal }) => getPlatformsDropdownOptions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformsDropdownOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>>
export type GetPlatformsDropdownOptionsQueryError = ErrorType<void>


export function useGetPlatformsDropdownOptions<TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformsDropdownOptions>>,
          TError,
          Awaited<ReturnType<typeof getPlatformsDropdownOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformsDropdownOptions<TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformsDropdownOptions>>,
          TError,
          Awaited<ReturnType<typeof getPlatformsDropdownOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformsDropdownOptions<TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets a lightweight list of platform dropdown options for the platform selector.
 */

export function useGetPlatformsDropdownOptions<TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformsDropdownOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPlatformsDropdownOptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformsDropdownOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>> = ({ signal }) => getPlatformsDropdownOptions(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPlatformsDropdownOptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>>
export type GetPlatformsDropdownOptionsSuspenseQueryError = ErrorType<void>


export function useGetPlatformsDropdownOptionsSuspense<TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformsDropdownOptionsSuspense<TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformsDropdownOptionsSuspense<TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets a lightweight list of platform dropdown options for the platform selector.
 */

export function useGetPlatformsDropdownOptionsSuspense<TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformsDropdownOptionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets a paginated list of platform summaries with optional search filtering.
 */
export const getPagedPlatformSummaries = (
    params?: GetPagedPlatformSummariesParams,
 signal?: AbortSignal
) => {


      return customAxios<DisplayPagedPlatformSummariesResponse>(
      {url: `/api/v1/platforms/summaries/paged`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetPagedPlatformSummariesQueryKey = (params?: GetPagedPlatformSummariesParams,) => {
    return [
    `/api/v1/platforms/summaries/paged`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPagedPlatformSummariesQueryOptions = <TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(params?: GetPagedPlatformSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPagedPlatformSummariesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPagedPlatformSummaries>>> = ({ signal }) => getPagedPlatformSummaries(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPagedPlatformSummariesQueryResult = NonNullable<Awaited<ReturnType<typeof getPagedPlatformSummaries>>>
export type GetPagedPlatformSummariesQueryError = ErrorType<void>


export function useGetPagedPlatformSummaries<TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(
 params: undefined |  GetPagedPlatformSummariesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPagedPlatformSummaries>>,
          TError,
          Awaited<ReturnType<typeof getPagedPlatformSummaries>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPagedPlatformSummaries<TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(
 params?: GetPagedPlatformSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPagedPlatformSummaries>>,
          TError,
          Awaited<ReturnType<typeof getPagedPlatformSummaries>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPagedPlatformSummaries<TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(
 params?: GetPagedPlatformSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets a paginated list of platform summaries with optional search filtering.
 */

export function useGetPagedPlatformSummaries<TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(
 params?: GetPagedPlatformSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPagedPlatformSummariesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPagedPlatformSummariesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(params?: GetPagedPlatformSummariesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPagedPlatformSummariesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPagedPlatformSummaries>>> = ({ signal }) => getPagedPlatformSummaries(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPagedPlatformSummariesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPagedPlatformSummaries>>>
export type GetPagedPlatformSummariesSuspenseQueryError = ErrorType<void>


export function useGetPagedPlatformSummariesSuspense<TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(
 params: undefined |  GetPagedPlatformSummariesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPagedPlatformSummariesSuspense<TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(
 params?: GetPagedPlatformSummariesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPagedPlatformSummariesSuspense<TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(
 params?: GetPagedPlatformSummariesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets a paginated list of platform summaries with optional search filtering.
 */

export function useGetPagedPlatformSummariesSuspense<TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(
 params?: GetPagedPlatformSummariesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPagedPlatformSummariesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets a single Platform by id.
 */
export const platformsGetPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}`, method: 'GET', signal
    },
      );
    }




export const getPlatformsGetPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}`
    ] as const;
    }


export const getPlatformsGetPlatformQueryOptions = <TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsGetPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsGetPlatform>>> = ({ signal }) => platformsGetPlatform(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformsGetPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof platformsGetPlatform>>>
export type PlatformsGetPlatformQueryError = ErrorType<void>


export function usePlatformsGetPlatform<TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformsGetPlatform>>,
          TError,
          Awaited<ReturnType<typeof platformsGetPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatform<TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformsGetPlatform>>,
          TError,
          Awaited<ReturnType<typeof platformsGetPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatform<TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets a single Platform by id.
 */

export function usePlatformsGetPlatform<TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformsGetPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformsGetPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsGetPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsGetPlatform>>> = ({ signal }) => platformsGetPlatform(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type PlatformsGetPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformsGetPlatform>>>
export type PlatformsGetPlatformSuspenseQueryError = ErrorType<void>


export function usePlatformsGetPlatformSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatformSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatformSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets a single Platform by id.
 */

export function usePlatformsGetPlatformSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformsGetPlatformSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Updates a Platform identified by Platform id.
 */
export const updatePlatform = (
    platformId: string,
    updatePlatformRequest: UpdatePlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformRequest, signal
    },
      );
    }




export const getUpdatePlatformMutationKey = () => ['updatePlatform'] as const;

export const getUpdatePlatformMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatform>>, TError,UpdatePlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatform>>, TError,UpdatePlatformMutationVariables, TContext> => {

const mutationKey = getUpdatePlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatform>>, UpdatePlatformMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlatform(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatform>>>
    export type UpdatePlatformMutationBody = UpdatePlatformRequest
    export type UpdatePlatformMutationError = ErrorType<void>
    export type UpdatePlatformMutationVariables = {platformId: string;data: UpdatePlatformRequest}

    /**
 * @summary Updates a Platform identified by Platform id.
 */
export const useUpdatePlatform = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatform>>, TError,UpdatePlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatform>>,
        TError,
        UpdatePlatformMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Gets a single Platform by id without user-specific data filtering.
The list of roles within `AuthorizeAdminRole` is supposed to be synced with
the list of roles specified on the RepeatMD.AdminApp.Controllers.Api.AdminUsersController
 */
export const getPlatformData = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}/data`, method: 'GET', signal
    },
      );
    }




export const getGetPlatformDataQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/data`
    ] as const;
    }


export const getGetPlatformDataQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformDataQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformData>>> = ({ signal }) => getPlatformData(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformData>>>
export type GetPlatformDataQueryError = ErrorType<void>


export function useGetPlatformData<TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformData>>,
          TError,
          Awaited<ReturnType<typeof getPlatformData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformData<TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformData>>,
          TError,
          Awaited<ReturnType<typeof getPlatformData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformData<TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets a single Platform by id without user-specific data filtering.
The list of roles within `AuthorizeAdminRole` is supposed to be synced with
the list of roles specified on the RepeatMD.AdminApp.Controllers.Api.AdminUsersController
 */

export function useGetPlatformData<TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformDataQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPlatformDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformDataQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformData>>> = ({ signal }) => getPlatformData(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPlatformDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformData>>>
export type GetPlatformDataSuspenseQueryError = ErrorType<void>


export function useGetPlatformDataSuspense<TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformDataSuspense<TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformDataSuspense<TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets a single Platform by id without user-specific data filtering.
The list of roles within `AuthorizeAdminRole` is supposed to be synced with
the list of roles specified on the RepeatMD.AdminApp.Controllers.Api.AdminUsersController
 */

export function useGetPlatformDataSuspense<TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformDataSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets available platform pricing tiers.
 */
export const getPricingTiers = (

 signal?: AbortSignal
) => {


      return customAxios<PlatformPricingTierModel[]>(
      {url: `/api/v1/platforms/pricing-tiers`, method: 'GET', signal
    },
      );
    }




export const getGetPricingTiersQueryKey = () => {
    return [
    `/api/v1/platforms/pricing-tiers`
    ] as const;
    }


export const getGetPricingTiersQueryOptions = <TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingTiersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricingTiers>>> = ({ signal }) => getPricingTiers(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPricingTiersQueryResult = NonNullable<Awaited<ReturnType<typeof getPricingTiers>>>
export type GetPricingTiersQueryError = ErrorType<unknown>


export function useGetPricingTiers<TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPricingTiers>>,
          TError,
          Awaited<ReturnType<typeof getPricingTiers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPricingTiers<TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPricingTiers>>,
          TError,
          Awaited<ReturnType<typeof getPricingTiers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPricingTiers<TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets available platform pricing tiers.
 */

export function useGetPricingTiers<TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPricingTiersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPricingTiersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingTiersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricingTiers>>> = ({ signal }) => getPricingTiers(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPricingTiersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPricingTiers>>>
export type GetPricingTiersSuspenseQueryError = ErrorType<unknown>


export function useGetPricingTiersSuspense<TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPricingTiersSuspense<TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPricingTiersSuspense<TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets available platform pricing tiers.
 */

export function useGetPricingTiersSuspense<TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPricingTiersSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update PlatformSettings for a particular Platform.
 */
export const updatePlatformSettings = (
    platformId: string,
    updatePlatformSettingsRequest: UpdatePlatformSettingsRequest,
 signal?: AbortSignal
) => {


      return customAxios<PlatformSettingsUpdatedEvent>(
      {url: `/api/v1/platforms/${platformId}/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformSettingsRequest, signal
    },
      );
    }




export const getUpdatePlatformSettingsMutationKey = () => ['updatePlatformSettings'] as const;

export const getUpdatePlatformSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformSettings>>, TError,UpdatePlatformSettingsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatformSettings>>, TError,UpdatePlatformSettingsMutationVariables, TContext> => {

const mutationKey = getUpdatePlatformSettingsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatformSettings>>, UpdatePlatformSettingsMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlatformSettings(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatformSettings>>>
    export type UpdatePlatformSettingsMutationBody = UpdatePlatformSettingsRequest
    export type UpdatePlatformSettingsMutationError = ErrorType<void>
    export type UpdatePlatformSettingsMutationVariables = {platformId: string;data: UpdatePlatformSettingsRequest}

    /**
 * @summary Update PlatformSettings for a particular Platform.
 */
export const useUpdatePlatformSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformSettings>>, TError,UpdatePlatformSettingsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatformSettings>>,
        TError,
        UpdatePlatformSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePlatformSettingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Update checkout tip settings for a platform. Practice-level admins can use this endpoint;
the full M:RepeatMD.AdminApp.Controllers.Api.PlatformsController.UpdatePlatformSettings(System.Guid,RepeatMD.Shared.Commands.Admin.Models.RequestModels.UpdatePlatformSettingsRequest,RepeatMD.Shared.Commands.Admin.Platforms.UpdatePlatformSettingsCommand) route remains restricted to RepeatMD staff.
 */
export const updatePlatformTipSettings = (
    platformId: string,
    updatePlatformTipSettingsRequest: UpdatePlatformTipSettingsRequest,
 signal?: AbortSignal
) => {


      return customAxios<PlatformSettingsUpdatedEvent>(
      {url: `/api/v1/platforms/${platformId}/settings/tips`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformTipSettingsRequest, signal
    },
      );
    }




export const getUpdatePlatformTipSettingsMutationKey = () => ['updatePlatformTipSettings'] as const;

export const getUpdatePlatformTipSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformTipSettings>>, TError,UpdatePlatformTipSettingsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatformTipSettings>>, TError,UpdatePlatformTipSettingsMutationVariables, TContext> => {

const mutationKey = getUpdatePlatformTipSettingsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatformTipSettings>>, UpdatePlatformTipSettingsMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlatformTipSettings(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformTipSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatformTipSettings>>>
    export type UpdatePlatformTipSettingsMutationBody = UpdatePlatformTipSettingsRequest
    export type UpdatePlatformTipSettingsMutationError = ErrorType<void>
    export type UpdatePlatformTipSettingsMutationVariables = {platformId: string;data: UpdatePlatformTipSettingsRequest}

    /**
 * @summary Update checkout tip settings for a platform. Practice-level admins can use this endpoint;
the full M:RepeatMD.AdminApp.Controllers.Api.PlatformsController.UpdatePlatformSettings(System.Guid,RepeatMD.Shared.Commands.Admin.Models.RequestModels.UpdatePlatformSettingsRequest,RepeatMD.Shared.Commands.Admin.Platforms.UpdatePlatformSettingsCommand) route remains restricted to RepeatMD staff.
 */
export const useUpdatePlatformTipSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformTipSettings>>, TError,UpdatePlatformTipSettingsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatformTipSettings>>,
        TError,
        UpdatePlatformTipSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePlatformTipSettingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Compares signed agreement evidence with actual processing fees at every active location without changing charges.
 */
export const retrievePlatformProcessingFeeReconciliation = (
    platformId: string,
    params?: RetrievePlatformProcessingFeeReconciliationParams,
 signal?: AbortSignal
) => {


      return customAxios<DisplayProcessingFeeReconciliationResponse>(
      {url: `/api/v1/platforms/${platformId}/processing-fee-reconciliation`, method: 'GET',
        params, signal
    },
      );
    }




export const getRetrievePlatformProcessingFeeReconciliationQueryKey = (platformId: string,
    params?: RetrievePlatformProcessingFeeReconciliationParams,) => {
    return [
    `/api/v1/platforms/${platformId}/processing-fee-reconciliation`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrievePlatformProcessingFeeReconciliationQueryOptions = <TData = Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: RetrievePlatformProcessingFeeReconciliationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrievePlatformProcessingFeeReconciliationQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>> = ({ signal }) => retrievePlatformProcessingFeeReconciliation(platformId,params, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RetrievePlatformProcessingFeeReconciliationQueryResult = NonNullable<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>>
export type RetrievePlatformProcessingFeeReconciliationQueryError = ErrorType<ProblemDetails>


export function useRetrievePlatformProcessingFeeReconciliation<TData = Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params: undefined |  RetrievePlatformProcessingFeeReconciliationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>,
          TError,
          Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrievePlatformProcessingFeeReconciliation<TData = Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: RetrievePlatformProcessingFeeReconciliationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>,
          TError,
          Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrievePlatformProcessingFeeReconciliation<TData = Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: RetrievePlatformProcessingFeeReconciliationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Compares signed agreement evidence with actual processing fees at every active location without changing charges.
 */

export function useRetrievePlatformProcessingFeeReconciliation<TData = Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: RetrievePlatformProcessingFeeReconciliationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetrievePlatformProcessingFeeReconciliationQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRetrievePlatformProcessingFeeReconciliationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: RetrievePlatformProcessingFeeReconciliationParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrievePlatformProcessingFeeReconciliationQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>> = ({ signal }) => retrievePlatformProcessingFeeReconciliation(platformId,params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type RetrievePlatformProcessingFeeReconciliationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>>
export type RetrievePlatformProcessingFeeReconciliationSuspenseQueryError = ErrorType<ProblemDetails>


export function useRetrievePlatformProcessingFeeReconciliationSuspense<TData = Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params: undefined |  RetrievePlatformProcessingFeeReconciliationParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrievePlatformProcessingFeeReconciliationSuspense<TData = Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: RetrievePlatformProcessingFeeReconciliationParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrievePlatformProcessingFeeReconciliationSuspense<TData = Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: RetrievePlatformProcessingFeeReconciliationParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Compares signed agreement evidence with actual processing fees at every active location without changing charges.
 */

export function useRetrievePlatformProcessingFeeReconciliationSuspense<TData = Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: RetrievePlatformProcessingFeeReconciliationParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePlatformProcessingFeeReconciliation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetrievePlatformProcessingFeeReconciliationSuspenseQueryOptions(platformId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update the fee configuration (service fee and processing fee amounts and obligations) for a platform.
Updates platform_settings and all active platform_payment_processors.
 */
export const updatePlatformFeeConfiguration = (
    platformId: string,
    updatePlatformFeeConfigurationRequest: UpdatePlatformFeeConfigurationRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/fee-configuration`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformFeeConfigurationRequest, signal
    },
      );
    }




export const getUpdatePlatformFeeConfigurationMutationKey = () => ['updatePlatformFeeConfiguration'] as const;

export const getUpdatePlatformFeeConfigurationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>, TError,UpdatePlatformFeeConfigurationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>, TError,UpdatePlatformFeeConfigurationMutationVariables, TContext> => {

const mutationKey = getUpdatePlatformFeeConfigurationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>, UpdatePlatformFeeConfigurationMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlatformFeeConfiguration(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformFeeConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>>
    export type UpdatePlatformFeeConfigurationMutationBody = UpdatePlatformFeeConfigurationRequest
    export type UpdatePlatformFeeConfigurationMutationError = ErrorType<void>
    export type UpdatePlatformFeeConfigurationMutationVariables = {platformId: string;data: UpdatePlatformFeeConfigurationRequest}

    /**
 * @summary Update the fee configuration (service fee and processing fee amounts and obligations) for a platform.
Updates platform_settings and all active platform_payment_processors.
 */
export const useUpdatePlatformFeeConfiguration = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>, TError,UpdatePlatformFeeConfigurationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>,
        TError,
        UpdatePlatformFeeConfigurationMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePlatformFeeConfigurationMutationOptions(options), queryClient);
    }
    /**
 * @summary Update PlatformDomain for a particular Platform.
 */
export const updatePlatformDomain = (
    platformId: string,
    updatePlatformDomainRequest: UpdatePlatformDomainRequest,
 signal?: AbortSignal
) => {


      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}/domain`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformDomainRequest, signal
    },
      );
    }




export const getUpdatePlatformDomainMutationKey = () => ['updatePlatformDomain'] as const;

export const getUpdatePlatformDomainMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformDomain>>, TError,UpdatePlatformDomainMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatformDomain>>, TError,UpdatePlatformDomainMutationVariables, TContext> => {

const mutationKey = getUpdatePlatformDomainMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatformDomain>>, UpdatePlatformDomainMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlatformDomain(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformDomainMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatformDomain>>>
    export type UpdatePlatformDomainMutationBody = UpdatePlatformDomainRequest
    export type UpdatePlatformDomainMutationError = ErrorType<void>
    export type UpdatePlatformDomainMutationVariables = {platformId: string;data: UpdatePlatformDomainRequest}

    /**
 * @summary Update PlatformDomain for a particular Platform.
 */
export const useUpdatePlatformDomain = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformDomain>>, TError,UpdatePlatformDomainMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatformDomain>>,
        TError,
        UpdatePlatformDomainMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePlatformDomainMutationOptions(options), queryClient);
    }
    /**
 * @summary Regenerates a platform's short links and re-queues its compensation calculation.
 */
export const regeneratePlatformShortLinks = (
    platformId: string,
    params?: RegeneratePlatformShortLinksParams,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCreatedPlatformResponse>(
      {url: `/api/v1/platforms/${platformId}/short-links/regenerate`, method: 'POST',
        params, signal
    },
      );
    }




export const getRegeneratePlatformShortLinksMutationKey = () => ['regeneratePlatformShortLinks'] as const;

export const getRegeneratePlatformShortLinksMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePlatformShortLinks>>, TError,RegeneratePlatformShortLinksMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regeneratePlatformShortLinks>>, TError,RegeneratePlatformShortLinksMutationVariables, TContext> => {

const mutationKey = getRegeneratePlatformShortLinksMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regeneratePlatformShortLinks>>, RegeneratePlatformShortLinksMutationVariables> = (props) => {
          const {platformId,params} = props ?? {};

          return  regeneratePlatformShortLinks(platformId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegeneratePlatformShortLinksMutationResult = NonNullable<Awaited<ReturnType<typeof regeneratePlatformShortLinks>>>

    export type RegeneratePlatformShortLinksMutationError = ErrorType<ProblemDetails>
    export type RegeneratePlatformShortLinksMutationVariables = {platformId: string;params?: RegeneratePlatformShortLinksParams}

    /**
 * @summary Regenerates a platform's short links and re-queues its compensation calculation.
 */
export const useRegeneratePlatformShortLinks = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePlatformShortLinks>>, TError,RegeneratePlatformShortLinksMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regeneratePlatformShortLinks>>,
        TError,
        RegeneratePlatformShortLinksMutationVariables,
        TContext
      > => {
      return useMutation(getRegeneratePlatformShortLinksMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves the configured domains for a platform.
 */
export const getPlatformDomains = (
    platformId: string,
    params?: GetPlatformDomainsParams,
 signal?: AbortSignal
) => {


      return customAxios<DisplayPlatformDomainResponse[]>(
      {url: `/api/v1/platforms/${platformId}/domains`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetPlatformDomainsQueryKey = (platformId: string,
    params?: GetPlatformDomainsParams,) => {
    return [
    `/api/v1/platforms/${platformId}/domains`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlatformDomainsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetPlatformDomainsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformDomainsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformDomains>>> = ({ signal }) => getPlatformDomains(platformId,params, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformDomainsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformDomains>>>
export type GetPlatformDomainsQueryError = ErrorType<ProblemDetails>


export function useGetPlatformDomains<TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params: undefined |  GetPlatformDomainsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformDomains>>,
          TError,
          Awaited<ReturnType<typeof getPlatformDomains>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformDomains<TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetPlatformDomainsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformDomains>>,
          TError,
          Awaited<ReturnType<typeof getPlatformDomains>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformDomains<TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetPlatformDomainsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the configured domains for a platform.
 */

export function useGetPlatformDomains<TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetPlatformDomainsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformDomainsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPlatformDomainsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetPlatformDomainsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformDomainsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformDomains>>> = ({ signal }) => getPlatformDomains(platformId,params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPlatformDomainsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformDomains>>>
export type GetPlatformDomainsSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetPlatformDomainsSuspense<TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params: undefined |  GetPlatformDomainsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformDomainsSuspense<TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetPlatformDomainsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformDomainsSuspense<TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetPlatformDomainsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the configured domains for a platform.
 */

export function useGetPlatformDomainsSuspense<TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetPlatformDomainsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformDomainsSuspenseQueryOptions(platformId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Requests and provisions a new custom domain for a platform.
 */
export const requestCustomDomain = (
    platformId: string,
    requestCustomDomainForPlatformRequest: RequestCustomDomainForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestCustomDomainForPlatformRequest, signal
    },
      );
    }




export const getRequestCustomDomainMutationKey = () => ['requestCustomDomain'] as const;

export const getRequestCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCustomDomain>>, TError,RequestCustomDomainMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof requestCustomDomain>>, TError,RequestCustomDomainMutationVariables, TContext> => {

const mutationKey = getRequestCustomDomainMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestCustomDomain>>, RequestCustomDomainMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  requestCustomDomain(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof requestCustomDomain>>>
    export type RequestCustomDomainMutationBody = RequestCustomDomainForPlatformRequest
    export type RequestCustomDomainMutationError = ErrorType<ProblemDetails>
    export type RequestCustomDomainMutationVariables = {platformId: string;data: RequestCustomDomainForPlatformRequest}

    /**
 * @summary Requests and provisions a new custom domain for a platform.
 */
export const useRequestCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCustomDomain>>, TError,RequestCustomDomainMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestCustomDomain>>,
        TError,
        RequestCustomDomainMutationVariables,
        TContext
      > => {
      return useMutation(getRequestCustomDomainMutationOptions(options), queryClient);
    }
    /**
 * @summary Starts the guided Basic Smart Site domain setup for an eligible platform administrator.
 */
export const setupBasicSmartSite = (
    platformId: string,
    requestCustomDomainForPlatformRequest: RequestCustomDomainForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayBasicSmartSiteLaunchConfigurationResponse>(
      {url: `/api/v1/platforms/${platformId}/basic-smart-site/setup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestCustomDomainForPlatformRequest, signal
    },
      );
    }




export const getSetupBasicSmartSiteMutationKey = () => ['setupBasicSmartSite'] as const;

export const getSetupBasicSmartSiteMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupBasicSmartSite>>, TError,SetupBasicSmartSiteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setupBasicSmartSite>>, TError,SetupBasicSmartSiteMutationVariables, TContext> => {

const mutationKey = getSetupBasicSmartSiteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setupBasicSmartSite>>, SetupBasicSmartSiteMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  setupBasicSmartSite(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetupBasicSmartSiteMutationResult = NonNullable<Awaited<ReturnType<typeof setupBasicSmartSite>>>
    export type SetupBasicSmartSiteMutationBody = RequestCustomDomainForPlatformRequest
    export type SetupBasicSmartSiteMutationError = ErrorType<ProblemDetails>
    export type SetupBasicSmartSiteMutationVariables = {platformId: string;data: RequestCustomDomainForPlatformRequest}

    /**
 * @summary Starts the guided Basic Smart Site domain setup for an eligible platform administrator.
 */
export const useSetupBasicSmartSite = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupBasicSmartSite>>, TError,SetupBasicSmartSiteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setupBasicSmartSite>>,
        TError,
        SetupBasicSmartSiteMutationVariables,
        TContext
      > => {
      return useMutation(getSetupBasicSmartSiteMutationOptions(options), queryClient);
    }
    /**
 * @summary Checks and resumes an existing custom domain without requiring a DNS automation callback.
 */
export const resumeCustomDomainActivation = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/resume`, method: 'POST', signal
    },
      );
    }




export const getResumeCustomDomainActivationMutationKey = () => ['resumeCustomDomainActivation'] as const;

export const getResumeCustomDomainActivationMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeCustomDomainActivation>>, TError,ResumeCustomDomainActivationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resumeCustomDomainActivation>>, TError,ResumeCustomDomainActivationMutationVariables, TContext> => {

const mutationKey = getResumeCustomDomainActivationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeCustomDomainActivation>>, ResumeCustomDomainActivationMutationVariables> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  resumeCustomDomainActivation(platformId,platformDomainId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResumeCustomDomainActivationMutationResult = NonNullable<Awaited<ReturnType<typeof resumeCustomDomainActivation>>>

    export type ResumeCustomDomainActivationMutationError = ErrorType<ProblemDetails>
    export type ResumeCustomDomainActivationMutationVariables = {platformId: string;platformDomainId: string}

    /**
 * @summary Checks and resumes an existing custom domain without requiring a DNS automation callback.
 */
export const useResumeCustomDomainActivation = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeCustomDomainActivation>>, TError,ResumeCustomDomainActivationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resumeCustomDomainActivation>>,
        TError,
        ResumeCustomDomainActivationMutationVariables,
        TContext
      > => {
      return useMutation(getResumeCustomDomainActivationMutationOptions(options), queryClient);
    }
    /**
 * @summary Verifies DNS ownership and certificate issuance for a platform's pending custom domain.
 */
export const verifyCustomDomain = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {


      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/verify`, method: 'POST', signal
    },
      );
    }




export const getVerifyCustomDomainMutationKey = () => ['verifyCustomDomain'] as const;

export const getVerifyCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCustomDomain>>, TError,VerifyCustomDomainMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verifyCustomDomain>>, TError,VerifyCustomDomainMutationVariables, TContext> => {

const mutationKey = getVerifyCustomDomainMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCustomDomain>>, VerifyCustomDomainMutationVariables> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  verifyCustomDomain(platformId,platformDomainId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCustomDomain>>>

    export type VerifyCustomDomainMutationError = ErrorType<ProblemDetails>
    export type VerifyCustomDomainMutationVariables = {platformId: string;platformDomainId: string}

    /**
 * @summary Verifies DNS ownership and certificate issuance for a platform's pending custom domain.
 */
export const useVerifyCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCustomDomain>>, TError,VerifyCustomDomainMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyCustomDomain>>,
        TError,
        VerifyCustomDomainMutationVariables,
        TContext
      > => {
      return useMutation(getVerifyCustomDomainMutationOptions(options), queryClient);
    }
    /**
 * @summary Deploys a verified custom domain so its routing can be activated.
 */
export const deployCustomDomain = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {


      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/deploy`, method: 'POST', signal
    },
      );
    }




export const getDeployCustomDomainMutationKey = () => ['deployCustomDomain'] as const;

export const getDeployCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deployCustomDomain>>, TError,DeployCustomDomainMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deployCustomDomain>>, TError,DeployCustomDomainMutationVariables, TContext> => {

const mutationKey = getDeployCustomDomainMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deployCustomDomain>>, DeployCustomDomainMutationVariables> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  deployCustomDomain(platformId,platformDomainId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeployCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof deployCustomDomain>>>

    export type DeployCustomDomainMutationError = ErrorType<ProblemDetails>
    export type DeployCustomDomainMutationVariables = {platformId: string;platformDomainId: string}

    /**
 * @summary Deploys a verified custom domain so its routing can be activated.
 */
export const useDeployCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deployCustomDomain>>, TError,DeployCustomDomainMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deployCustomDomain>>,
        TError,
        DeployCustomDomainMutationVariables,
        TContext
      > => {
      return useMutation(getDeployCustomDomainMutationOptions(options), queryClient);
    }
    /**
 * @summary Verifies that a deployed custom domain is routing correctly and activates it.
 */
export const verifyRoutingCustomDomain = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {


      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/verify-routing`, method: 'POST', signal
    },
      );
    }




export const getVerifyRoutingCustomDomainMutationKey = () => ['verifyRoutingCustomDomain'] as const;

export const getVerifyRoutingCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyRoutingCustomDomain>>, TError,VerifyRoutingCustomDomainMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verifyRoutingCustomDomain>>, TError,VerifyRoutingCustomDomainMutationVariables, TContext> => {

const mutationKey = getVerifyRoutingCustomDomainMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyRoutingCustomDomain>>, VerifyRoutingCustomDomainMutationVariables> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  verifyRoutingCustomDomain(platformId,platformDomainId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyRoutingCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof verifyRoutingCustomDomain>>>

    export type VerifyRoutingCustomDomainMutationError = ErrorType<ProblemDetails>
    export type VerifyRoutingCustomDomainMutationVariables = {platformId: string;platformDomainId: string}

    /**
 * @summary Verifies that a deployed custom domain is routing correctly and activates it.
 */
export const useVerifyRoutingCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyRoutingCustomDomain>>, TError,VerifyRoutingCustomDomainMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyRoutingCustomDomain>>,
        TError,
        VerifyRoutingCustomDomainMutationVariables,
        TContext
      > => {
      return useMutation(getVerifyRoutingCustomDomainMutationOptions(options), queryClient);
    }
    /**
 * @summary Confirms staff-reviewed routing evidence and activates the domain only after fresh checks pass.
 */
export const confirmCustomDomainRouting = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/confirm-routing`, method: 'POST', signal
    },
      );
    }




export const getConfirmCustomDomainRoutingMutationKey = () => ['confirmCustomDomainRouting'] as const;

export const getConfirmCustomDomainRoutingMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCustomDomainRouting>>, TError,ConfirmCustomDomainRoutingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmCustomDomainRouting>>, TError,ConfirmCustomDomainRoutingMutationVariables, TContext> => {

const mutationKey = getConfirmCustomDomainRoutingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmCustomDomainRouting>>, ConfirmCustomDomainRoutingMutationVariables> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  confirmCustomDomainRouting(platformId,platformDomainId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmCustomDomainRoutingMutationResult = NonNullable<Awaited<ReturnType<typeof confirmCustomDomainRouting>>>

    export type ConfirmCustomDomainRoutingMutationError = ErrorType<ProblemDetails>
    export type ConfirmCustomDomainRoutingMutationVariables = {platformId: string;platformDomainId: string}

    /**
 * @summary Confirms staff-reviewed routing evidence and activates the domain only after fresh checks pass.
 */
export const useConfirmCustomDomainRouting = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCustomDomainRouting>>, TError,ConfirmCustomDomainRoutingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmCustomDomainRouting>>,
        TError,
        ConfirmCustomDomainRoutingMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmCustomDomainRoutingMutationOptions(options), queryClient);
    }
    /**
 * @summary Permanently deletes a disabled custom domain from a platform.
 */
export const deleteCustomDomain = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {


      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/delete`, method: 'POST', signal
    },
      );
    }




export const getDeleteCustomDomainMutationKey = () => ['deleteCustomDomain'] as const;

export const getDeleteCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomDomain>>, TError,DeleteCustomDomainMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomDomain>>, TError,DeleteCustomDomainMutationVariables, TContext> => {

const mutationKey = getDeleteCustomDomainMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomDomain>>, DeleteCustomDomainMutationVariables> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  deleteCustomDomain(platformId,platformDomainId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomDomain>>>

    export type DeleteCustomDomainMutationError = ErrorType<ProblemDetails>
    export type DeleteCustomDomainMutationVariables = {platformId: string;platformDomainId: string}

    /**
 * @summary Permanently deletes a disabled custom domain from a platform.
 */
export const useDeleteCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomDomain>>, TError,DeleteCustomDomainMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomDomain>>,
        TError,
        DeleteCustomDomainMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteCustomDomainMutationOptions(options), queryClient);
    }
    /**
 * @summary Disables an active custom domain for a platform.
 */
export const disableCustomDomain = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {


      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}`, method: 'DELETE', signal
    },
      );
    }




export const getDisableCustomDomainMutationKey = () => ['disableCustomDomain'] as const;

export const getDisableCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableCustomDomain>>, TError,DisableCustomDomainMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableCustomDomain>>, TError,DisableCustomDomainMutationVariables, TContext> => {

const mutationKey = getDisableCustomDomainMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableCustomDomain>>, DisableCustomDomainMutationVariables> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  disableCustomDomain(platformId,platformDomainId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof disableCustomDomain>>>

    export type DisableCustomDomainMutationError = ErrorType<ProblemDetails>
    export type DisableCustomDomainMutationVariables = {platformId: string;platformDomainId: string}

    /**
 * @summary Disables an active custom domain for a platform.
 */
export const useDisableCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableCustomDomain>>, TError,DisableCustomDomainMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableCustomDomain>>,
        TError,
        DisableCustomDomainMutationVariables,
        TContext
      > => {
      return useMutation(getDisableCustomDomainMutationOptions(options), queryClient);
    }
    /**
 * @summary Creates a new PlatformLocation.
 */
export const platformsCreatePlatformLocation = (
    platformId: string,
    updatePlatformLocationRequest: UpdatePlatformLocationRequest,
 signal?: AbortSignal
) => {


      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}/locations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformLocationRequest, signal
    },
      );
    }




export const getPlatformsCreatePlatformLocationMutationKey = () => ['platformsCreatePlatformLocation'] as const;

export const getPlatformsCreatePlatformLocationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsCreatePlatformLocation>>, TError,PlatformsCreatePlatformLocationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsCreatePlatformLocation>>, TError,PlatformsCreatePlatformLocationMutationVariables, TContext> => {

const mutationKey = getPlatformsCreatePlatformLocationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsCreatePlatformLocation>>, PlatformsCreatePlatformLocationMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsCreatePlatformLocation(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformsCreatePlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof platformsCreatePlatformLocation>>>
    export type PlatformsCreatePlatformLocationMutationBody = UpdatePlatformLocationRequest
    export type PlatformsCreatePlatformLocationMutationError = ErrorType<void>
    export type PlatformsCreatePlatformLocationMutationVariables = {platformId: string;data: UpdatePlatformLocationRequest}

    /**
 * @summary Creates a new PlatformLocation.
 */
export const usePlatformsCreatePlatformLocation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsCreatePlatformLocation>>, TError,PlatformsCreatePlatformLocationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformsCreatePlatformLocation>>,
        TError,
        PlatformsCreatePlatformLocationMutationVariables,
        TContext
      > => {
      return useMutation(getPlatformsCreatePlatformLocationMutationOptions(options), queryClient);
    }
    /**
 * @summary Updates a PlatformLocation identified by PlatformLocation id.
 */
export const platformsUpdatePlatformLocation = (
    platformId: string,
    locationId: string,
    updatePlatformLocationRequest: UpdatePlatformLocationRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCreatedPlatformResponse>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformLocationRequest, signal
    },
      );
    }




export const getPlatformsUpdatePlatformLocationMutationKey = () => ['platformsUpdatePlatformLocation'] as const;

export const getPlatformsUpdatePlatformLocationMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>, TError,PlatformsUpdatePlatformLocationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>, TError,PlatformsUpdatePlatformLocationMutationVariables, TContext> => {

const mutationKey = getPlatformsUpdatePlatformLocationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>, PlatformsUpdatePlatformLocationMutationVariables> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  platformsUpdatePlatformLocation(platformId,locationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformsUpdatePlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>>
    export type PlatformsUpdatePlatformLocationMutationBody = UpdatePlatformLocationRequest
    export type PlatformsUpdatePlatformLocationMutationError = ErrorType<ProblemDetails>
    export type PlatformsUpdatePlatformLocationMutationVariables = {platformId: string;locationId: string;data: UpdatePlatformLocationRequest}

    /**
 * @summary Updates a PlatformLocation identified by PlatformLocation id.
 */
export const usePlatformsUpdatePlatformLocation = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>, TError,PlatformsUpdatePlatformLocationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>,
        TError,
        PlatformsUpdatePlatformLocationMutationVariables,
        TContext
      > => {
      return useMutation(getPlatformsUpdatePlatformLocationMutationOptions(options), queryClient);
    }
    /**
 * @summary Deletes a PlatformLocation identified by PlatformLocation id.
 */
export const deletePlatformLocation = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {


      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeletePlatformLocationMutationKey = () => ['deletePlatformLocation'] as const;

export const getDeletePlatformLocationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlatformLocation>>, TError,DeletePlatformLocationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePlatformLocation>>, TError,DeletePlatformLocationMutationVariables, TContext> => {

const mutationKey = getDeletePlatformLocationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlatformLocation>>, DeletePlatformLocationMutationVariables> = (props) => {
          const {platformId,locationId} = props ?? {};

          return  deletePlatformLocation(platformId,locationId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlatformLocation>>>

    export type DeletePlatformLocationMutationError = ErrorType<void>
    export type DeletePlatformLocationMutationVariables = {platformId: string;locationId: string}

    /**
 * @summary Deletes a PlatformLocation identified by PlatformLocation id.
 */
export const useDeletePlatformLocation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlatformLocation>>, TError,DeletePlatformLocationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePlatformLocation>>,
        TError,
        DeletePlatformLocationMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePlatformLocationMutationOptions(options), queryClient);
    }
    /**
 * @summary Activates a PlatformLocation. This operation is restricted to RepeatMD administrators.
 */
export const activatePlatformLocation = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/activate`, method: 'PUT', signal
    },
      );
    }




export const getActivatePlatformLocationMutationKey = () => ['activatePlatformLocation'] as const;

export const getActivatePlatformLocationMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePlatformLocation>>, TError,ActivatePlatformLocationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activatePlatformLocation>>, TError,ActivatePlatformLocationMutationVariables, TContext> => {

const mutationKey = getActivatePlatformLocationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activatePlatformLocation>>, ActivatePlatformLocationMutationVariables> = (props) => {
          const {platformId,locationId} = props ?? {};

          return  activatePlatformLocation(platformId,locationId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivatePlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof activatePlatformLocation>>>

    export type ActivatePlatformLocationMutationError = ErrorType<ProblemDetails>
    export type ActivatePlatformLocationMutationVariables = {platformId: string;locationId: string}

    /**
 * @summary Activates a PlatformLocation. This operation is restricted to RepeatMD administrators.
 */
export const useActivatePlatformLocation = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePlatformLocation>>, TError,ActivatePlatformLocationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activatePlatformLocation>>,
        TError,
        ActivatePlatformLocationMutationVariables,
        TContext
      > => {
      return useMutation(getActivatePlatformLocationMutationOptions(options), queryClient);
    }
    /**
 * @summary Deactivates a PlatformLocation. This operation is restricted to RepeatMD administrators.
 */
export const deactivatePlatformLocation = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/deactivate`, method: 'PUT', signal
    },
      );
    }




export const getDeactivatePlatformLocationMutationKey = () => ['deactivatePlatformLocation'] as const;

export const getDeactivatePlatformLocationMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivatePlatformLocation>>, TError,DeactivatePlatformLocationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivatePlatformLocation>>, TError,DeactivatePlatformLocationMutationVariables, TContext> => {

const mutationKey = getDeactivatePlatformLocationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivatePlatformLocation>>, DeactivatePlatformLocationMutationVariables> = (props) => {
          const {platformId,locationId} = props ?? {};

          return  deactivatePlatformLocation(platformId,locationId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivatePlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof deactivatePlatformLocation>>>

    export type DeactivatePlatformLocationMutationError = ErrorType<ProblemDetails>
    export type DeactivatePlatformLocationMutationVariables = {platformId: string;locationId: string}

    /**
 * @summary Deactivates a PlatformLocation. This operation is restricted to RepeatMD administrators.
 */
export const useDeactivatePlatformLocation = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivatePlatformLocation>>, TError,DeactivatePlatformLocationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivatePlatformLocation>>,
        TError,
        DeactivatePlatformLocationMutationVariables,
        TContext
      > => {
      return useMutation(getDeactivatePlatformLocationMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves operating hours for a platform location.
 */
export const getPlatformLocationOperatingHours = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayOperatingHoursForPlatformLocation>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/operating-hours`, method: 'GET', signal
    },
      );
    }




export const getGetPlatformLocationOperatingHoursQueryKey = (platformId: string,
    locationId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/locations/${locationId}/operating-hours`
    ] as const;
    }


export const getGetPlatformLocationOperatingHoursQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(platformId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformLocationOperatingHoursQueryKey(platformId,locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>> = ({ signal }) => getPlatformLocationOperatingHours(platformId,locationId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined && locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformLocationOperatingHoursQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>>
export type GetPlatformLocationOperatingHoursQueryError = ErrorType<void>


export function useGetPlatformLocationOperatingHours<TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(
 platformId: string,
    locationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocationOperatingHours<TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocationOperatingHours<TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves operating hours for a platform location.
 */

export function useGetPlatformLocationOperatingHours<TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformLocationOperatingHoursQueryOptions(platformId,locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPlatformLocationOperatingHoursSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(platformId: string,
    locationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformLocationOperatingHoursQueryKey(platformId,locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>> = ({ signal }) => getPlatformLocationOperatingHours(platformId,locationId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPlatformLocationOperatingHoursSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>>
export type GetPlatformLocationOperatingHoursSuspenseQueryError = ErrorType<void>


export function useGetPlatformLocationOperatingHoursSuspense<TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(
 platformId: string,
    locationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocationOperatingHoursSuspense<TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocationOperatingHoursSuspense<TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves operating hours for a platform location.
 */

export function useGetPlatformLocationOperatingHoursSuspense<TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformLocationOperatingHoursSuspenseQueryOptions(platformId,locationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Updates operating hours for a platform location.
 */
export const setPlatformLocationOperatingHours = (
    platformId: string,
    locationId: string,
    setOperatingHoursForPlatformLocationRequest: SetOperatingHoursForPlatformLocationRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/operating-hours`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setOperatingHoursForPlatformLocationRequest, signal
    },
      );
    }




export const getSetPlatformLocationOperatingHoursMutationKey = () => ['setPlatformLocationOperatingHours'] as const;

export const getSetPlatformLocationOperatingHoursMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>, TError,SetPlatformLocationOperatingHoursMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>, TError,SetPlatformLocationOperatingHoursMutationVariables, TContext> => {

const mutationKey = getSetPlatformLocationOperatingHoursMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>, SetPlatformLocationOperatingHoursMutationVariables> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setPlatformLocationOperatingHours(platformId,locationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPlatformLocationOperatingHoursMutationResult = NonNullable<Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>>
    export type SetPlatformLocationOperatingHoursMutationBody = SetOperatingHoursForPlatformLocationRequest
    export type SetPlatformLocationOperatingHoursMutationError = ErrorType<void>
    export type SetPlatformLocationOperatingHoursMutationVariables = {platformId: string;locationId: string;data: SetOperatingHoursForPlatformLocationRequest}

    /**
 * @summary Updates operating hours for a platform location.
 */
export const useSetPlatformLocationOperatingHours = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>, TError,SetPlatformLocationOperatingHoursMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>,
        TError,
        SetPlatformLocationOperatingHoursMutationVariables,
        TContext
      > => {
      return useMutation(getSetPlatformLocationOperatingHoursMutationOptions(options), queryClient);
    }
    /**
 * @summary Gets the timezones for all locations of a Platform.
 */
export const getPlatformLocationsTimezones = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<PlatformLocationsTimezonesResult[]>(
      {url: `/api/v1/platforms/${platformId}/locations/timezones`, method: 'GET', signal
    },
      );
    }




export const getGetPlatformLocationsTimezonesQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/locations/timezones`
    ] as const;
    }


export const getGetPlatformLocationsTimezonesQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformLocationsTimezonesQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>> = ({ signal }) => getPlatformLocationsTimezones(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformLocationsTimezonesQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>>
export type GetPlatformLocationsTimezonesQueryError = ErrorType<void>


export function useGetPlatformLocationsTimezones<TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocationsTimezones>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocationsTimezones>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocationsTimezones<TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocationsTimezones>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocationsTimezones>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocationsTimezones<TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the timezones for all locations of a Platform.
 */

export function useGetPlatformLocationsTimezones<TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformLocationsTimezonesQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPlatformLocationsTimezonesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformLocationsTimezonesQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>> = ({ signal }) => getPlatformLocationsTimezones(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPlatformLocationsTimezonesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>>
export type GetPlatformLocationsTimezonesSuspenseQueryError = ErrorType<void>


export function useGetPlatformLocationsTimezonesSuspense<TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocationsTimezonesSuspense<TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocationsTimezonesSuspense<TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the timezones for all locations of a Platform.
 */

export function useGetPlatformLocationsTimezonesSuspense<TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformLocationsTimezonesSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets statistic regarding transactions of a Platform.
 */
export const getPlatformTransactionStats = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<GetPlatformTransactionsStatsResult>(
      {url: `/api/v1/platforms/${platformId}/transactions-stats`, method: 'GET', signal
    },
      );
    }




export const getGetPlatformTransactionStatsQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/transactions-stats`
    ] as const;
    }


export const getGetPlatformTransactionStatsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformTransactionStatsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformTransactionStats>>> = ({ signal }) => getPlatformTransactionStats(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformTransactionStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformTransactionStats>>>
export type GetPlatformTransactionStatsQueryError = ErrorType<void>


export function useGetPlatformTransactionStats<TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformTransactionStats>>,
          TError,
          Awaited<ReturnType<typeof getPlatformTransactionStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformTransactionStats<TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformTransactionStats>>,
          TError,
          Awaited<ReturnType<typeof getPlatformTransactionStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformTransactionStats<TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets statistic regarding transactions of a Platform.
 */

export function useGetPlatformTransactionStats<TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformTransactionStatsQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPlatformTransactionStatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformTransactionStatsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformTransactionStats>>> = ({ signal }) => getPlatformTransactionStats(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPlatformTransactionStatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformTransactionStats>>>
export type GetPlatformTransactionStatsSuspenseQueryError = ErrorType<void>


export function useGetPlatformTransactionStatsSuspense<TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformTransactionStatsSuspense<TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformTransactionStatsSuspense<TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets statistic regarding transactions of a Platform.
 */

export function useGetPlatformTransactionStatsSuspense<TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformTransactionStatsSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets statistic regarding payouts of a Platform.
 */
export const platformsGetPlatformPayoutsStats = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<GetPlatformPayoutsStatsResult>(
      {url: `/api/v1/platforms/${platformId}/payouts-stats`, method: 'GET', signal
    },
      );
    }




export const getPlatformsGetPlatformPayoutsStatsQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/payouts-stats`
    ] as const;
    }


export const getPlatformsGetPlatformPayoutsStatsQueryOptions = <TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsGetPlatformPayoutsStatsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>> = ({ signal }) => platformsGetPlatformPayoutsStats(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformsGetPlatformPayoutsStatsQueryResult = NonNullable<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>>
export type PlatformsGetPlatformPayoutsStatsQueryError = ErrorType<void>


export function usePlatformsGetPlatformPayoutsStats<TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>,
          TError,
          Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatformPayoutsStats<TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>,
          TError,
          Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatformPayoutsStats<TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets statistic regarding payouts of a Platform.
 */

export function usePlatformsGetPlatformPayoutsStats<TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformsGetPlatformPayoutsStatsQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformsGetPlatformPayoutsStatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsGetPlatformPayoutsStatsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>> = ({ signal }) => platformsGetPlatformPayoutsStats(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type PlatformsGetPlatformPayoutsStatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>>
export type PlatformsGetPlatformPayoutsStatsSuspenseQueryError = ErrorType<void>


export function usePlatformsGetPlatformPayoutsStatsSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatformPayoutsStatsSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformsGetPlatformPayoutsStatsSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets statistic regarding payouts of a Platform.
 */

export function usePlatformsGetPlatformPayoutsStatsSuspense<TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformsGetPlatformPayoutsStatsSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Associates a Salesforce ID with a Platform.
 */
export const platformsAssociateSalesforceIdToPlatform = (
    platformId: string,
    associateSalesforceIdToPlatformRequest: AssociateSalesforceIdToPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<SalesforceIdAssociatedToPlatformEvent>(
      {url: `/api/v1/platforms/${platformId}/associate-salesforce-id`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: associateSalesforceIdToPlatformRequest, signal
    },
      );
    }




export const getPlatformsAssociateSalesforceIdToPlatformMutationKey = () => ['platformsAssociateSalesforceIdToPlatform'] as const;

export const getPlatformsAssociateSalesforceIdToPlatformMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>, TError,PlatformsAssociateSalesforceIdToPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>, TError,PlatformsAssociateSalesforceIdToPlatformMutationVariables, TContext> => {

const mutationKey = getPlatformsAssociateSalesforceIdToPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>, PlatformsAssociateSalesforceIdToPlatformMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsAssociateSalesforceIdToPlatform(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformsAssociateSalesforceIdToPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>>
    export type PlatformsAssociateSalesforceIdToPlatformMutationBody = AssociateSalesforceIdToPlatformRequest
    export type PlatformsAssociateSalesforceIdToPlatformMutationError = ErrorType<void>
    export type PlatformsAssociateSalesforceIdToPlatformMutationVariables = {platformId: string;data: AssociateSalesforceIdToPlatformRequest}

    /**
 * @summary Associates a Salesforce ID with a Platform.
 */
export const usePlatformsAssociateSalesforceIdToPlatform = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>, TError,PlatformsAssociateSalesforceIdToPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>,
        TError,
        PlatformsAssociateSalesforceIdToPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getPlatformsAssociateSalesforceIdToPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Associates a Salesforce Account ID with a Platform.
 */
export const platformsAssociateSalesforceAccountIdToPlatform = (
    platformId: string,
    associateSalesforceAccountIdToPlatformRequest: AssociateSalesforceAccountIdToPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<SalesforceAccountIdAssociatedToPlatformEvent>(
      {url: `/api/v1/platforms/${platformId}/associate-salesforce-account-id`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: associateSalesforceAccountIdToPlatformRequest, signal
    },
      );
    }




export const getPlatformsAssociateSalesforceAccountIdToPlatformMutationKey = () => ['platformsAssociateSalesforceAccountIdToPlatform'] as const;

export const getPlatformsAssociateSalesforceAccountIdToPlatformMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>, TError,PlatformsAssociateSalesforceAccountIdToPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>, TError,PlatformsAssociateSalesforceAccountIdToPlatformMutationVariables, TContext> => {

const mutationKey = getPlatformsAssociateSalesforceAccountIdToPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>, PlatformsAssociateSalesforceAccountIdToPlatformMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsAssociateSalesforceAccountIdToPlatform(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformsAssociateSalesforceAccountIdToPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>>
    export type PlatformsAssociateSalesforceAccountIdToPlatformMutationBody = AssociateSalesforceAccountIdToPlatformRequest
    export type PlatformsAssociateSalesforceAccountIdToPlatformMutationError = ErrorType<void>
    export type PlatformsAssociateSalesforceAccountIdToPlatformMutationVariables = {platformId: string;data: AssociateSalesforceAccountIdToPlatformRequest}

    /**
 * @summary Associates a Salesforce Account ID with a Platform.
 */
export const usePlatformsAssociateSalesforceAccountIdToPlatform = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>, TError,PlatformsAssociateSalesforceAccountIdToPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>,
        TError,
        PlatformsAssociateSalesforceAccountIdToPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getPlatformsAssociateSalesforceAccountIdToPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Sets the Salesforce parent Account Id for a Platform.
 */
export const platformsSetSalesforceParentAccountIdForPlatform = (
    platformId: string,
    setSalesforceParentAccountIdForPlatformRequest: SetSalesforceParentAccountIdForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/set-salesforce-parent-account-id`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setSalesforceParentAccountIdForPlatformRequest, signal
    },
      );
    }




export const getPlatformsSetSalesforceParentAccountIdForPlatformMutationKey = () => ['platformsSetSalesforceParentAccountIdForPlatform'] as const;

export const getPlatformsSetSalesforceParentAccountIdForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>, TError,PlatformsSetSalesforceParentAccountIdForPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>, TError,PlatformsSetSalesforceParentAccountIdForPlatformMutationVariables, TContext> => {

const mutationKey = getPlatformsSetSalesforceParentAccountIdForPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>, PlatformsSetSalesforceParentAccountIdForPlatformMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsSetSalesforceParentAccountIdForPlatform(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformsSetSalesforceParentAccountIdForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>>
    export type PlatformsSetSalesforceParentAccountIdForPlatformMutationBody = SetSalesforceParentAccountIdForPlatformRequest
    export type PlatformsSetSalesforceParentAccountIdForPlatformMutationError = ErrorType<unknown>
    export type PlatformsSetSalesforceParentAccountIdForPlatformMutationVariables = {platformId: string;data: SetSalesforceParentAccountIdForPlatformRequest}

    /**
 * @summary Sets the Salesforce parent Account Id for a Platform.
 */
export const usePlatformsSetSalesforceParentAccountIdForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>, TError,PlatformsSetSalesforceParentAccountIdForPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>,
        TError,
        PlatformsSetSalesforceParentAccountIdForPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getPlatformsSetSalesforceParentAccountIdForPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Sets the Salesforce RepeatMD Opportunity Id for a Platform.
 */
export const platformsSetRepeatMdOpportunityForPlatform = (
    platformId: string,
    setRepeatMdOpportunityForPlatformRequest: SetRepeatMdOpportunityForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/set-repeatmd-opportunity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setRepeatMdOpportunityForPlatformRequest, signal
    },
      );
    }




export const getPlatformsSetRepeatMdOpportunityForPlatformMutationKey = () => ['platformsSetRepeatMdOpportunityForPlatform'] as const;

export const getPlatformsSetRepeatMdOpportunityForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>, TError,PlatformsSetRepeatMdOpportunityForPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>, TError,PlatformsSetRepeatMdOpportunityForPlatformMutationVariables, TContext> => {

const mutationKey = getPlatformsSetRepeatMdOpportunityForPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>, PlatformsSetRepeatMdOpportunityForPlatformMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsSetRepeatMdOpportunityForPlatform(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformsSetRepeatMdOpportunityForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>>
    export type PlatformsSetRepeatMdOpportunityForPlatformMutationBody = SetRepeatMdOpportunityForPlatformRequest
    export type PlatformsSetRepeatMdOpportunityForPlatformMutationError = ErrorType<unknown>
    export type PlatformsSetRepeatMdOpportunityForPlatformMutationVariables = {platformId: string;data: SetRepeatMdOpportunityForPlatformRequest}

    /**
 * @summary Sets the Salesforce RepeatMD Opportunity Id for a Platform.
 */
export const usePlatformsSetRepeatMdOpportunityForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>, TError,PlatformsSetRepeatMdOpportunityForPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>,
        TError,
        PlatformsSetRepeatMdOpportunityForPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getPlatformsSetRepeatMdOpportunityForPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Sets the Salesforce Ageless Opportunity Id for a Platform.
 */
export const platformsSetAgelessOpportunityForPlatform = (
    platformId: string,
    setAgelessOpportunityForPlatformRequest: SetAgelessOpportunityForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/set-ageless-opportunity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOpportunityForPlatformRequest, signal
    },
      );
    }




export const getPlatformsSetAgelessOpportunityForPlatformMutationKey = () => ['platformsSetAgelessOpportunityForPlatform'] as const;

export const getPlatformsSetAgelessOpportunityForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>, TError,PlatformsSetAgelessOpportunityForPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>, TError,PlatformsSetAgelessOpportunityForPlatformMutationVariables, TContext> => {

const mutationKey = getPlatformsSetAgelessOpportunityForPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>, PlatformsSetAgelessOpportunityForPlatformMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsSetAgelessOpportunityForPlatform(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformsSetAgelessOpportunityForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>>
    export type PlatformsSetAgelessOpportunityForPlatformMutationBody = SetAgelessOpportunityForPlatformRequest
    export type PlatformsSetAgelessOpportunityForPlatformMutationError = ErrorType<unknown>
    export type PlatformsSetAgelessOpportunityForPlatformMutationVariables = {platformId: string;data: SetAgelessOpportunityForPlatformRequest}

    /**
 * @summary Sets the Salesforce Ageless Opportunity Id for a Platform.
 */
export const usePlatformsSetAgelessOpportunityForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>, TError,PlatformsSetAgelessOpportunityForPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>,
        TError,
        PlatformsSetAgelessOpportunityForPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getPlatformsSetAgelessOpportunityForPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Associates a Practice Type with a Platform from Salesforce.
 */
export const platformsAssociatePracticeTypeToPlatform = (
    platformId: string,
    associatePracticeTypeToPlatformRequest: AssociatePracticeTypeToPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<PracticeTypeAssociatedToPlatformEvent>(
      {url: `/api/v1/platforms/${platformId}/associate-practice-type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: associatePracticeTypeToPlatformRequest, signal
    },
      );
    }




export const getPlatformsAssociatePracticeTypeToPlatformMutationKey = () => ['platformsAssociatePracticeTypeToPlatform'] as const;

export const getPlatformsAssociatePracticeTypeToPlatformMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>, TError,PlatformsAssociatePracticeTypeToPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>, TError,PlatformsAssociatePracticeTypeToPlatformMutationVariables, TContext> => {

const mutationKey = getPlatformsAssociatePracticeTypeToPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>, PlatformsAssociatePracticeTypeToPlatformMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsAssociatePracticeTypeToPlatform(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformsAssociatePracticeTypeToPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>>
    export type PlatformsAssociatePracticeTypeToPlatformMutationBody = AssociatePracticeTypeToPlatformRequest
    export type PlatformsAssociatePracticeTypeToPlatformMutationError = ErrorType<void>
    export type PlatformsAssociatePracticeTypeToPlatformMutationVariables = {platformId: string;data: AssociatePracticeTypeToPlatformRequest}

    /**
 * @summary Associates a Practice Type with a Platform from Salesforce.
 */
export const usePlatformsAssociatePracticeTypeToPlatform = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>, TError,PlatformsAssociatePracticeTypeToPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>,
        TError,
        PlatformsAssociatePracticeTypeToPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getPlatformsAssociatePracticeTypeToPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns billing information for the specified Platform.
 */
export const getBillingInfoForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<CompanyBillingInfo>(
      {url: `/api/v1/platforms/${platformId}/billing-info`, method: 'GET', signal
    },
      );
    }




export const getGetBillingInfoForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/billing-info`
    ] as const;
    }


export const getGetBillingInfoForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInfoForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInfoForPlatform>>> = ({ signal }) => getBillingInfoForPlatform(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingInfoForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInfoForPlatform>>>
export type GetBillingInfoForPlatformQueryError = ErrorType<unknown>


export function useGetBillingInfoForPlatform<TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingInfoForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getBillingInfoForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingInfoForPlatform<TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingInfoForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getBillingInfoForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingInfoForPlatform<TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns billing information for the specified Platform.
 */

export function useGetBillingInfoForPlatform<TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingInfoForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBillingInfoForPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInfoForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInfoForPlatform>>> = ({ signal }) => getBillingInfoForPlatform(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetBillingInfoForPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInfoForPlatform>>>
export type GetBillingInfoForPlatformSuspenseQueryError = ErrorType<unknown>


export function useGetBillingInfoForPlatformSuspense<TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingInfoForPlatformSuspense<TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingInfoForPlatformSuspense<TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns billing information for the specified Platform.
 */

export function useGetBillingInfoForPlatformSuspense<TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingInfoForPlatformSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns PLG onboarding scheduling details for the specified Platform,
including the customer success meeting link, meeting datetime, and CEM information.
 */
export const getPlgOnboardingScheduling = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayPlgOnboardingSchedulingDetails>(
      {url: `/api/v1/platforms/${platformId}/plg-onboarding-scheduling`, method: 'GET', signal
    },
      );
    }




export const getGetPlgOnboardingSchedulingQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/plg-onboarding-scheduling`
    ] as const;
    }


export const getGetPlgOnboardingSchedulingQueryOptions = <TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlgOnboardingSchedulingQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>> = ({ signal }) => getPlgOnboardingScheduling(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlgOnboardingSchedulingQueryResult = NonNullable<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>>
export type GetPlgOnboardingSchedulingQueryError = ErrorType<void>


export function useGetPlgOnboardingScheduling<TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlgOnboardingScheduling>>,
          TError,
          Awaited<ReturnType<typeof getPlgOnboardingScheduling>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlgOnboardingScheduling<TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlgOnboardingScheduling>>,
          TError,
          Awaited<ReturnType<typeof getPlgOnboardingScheduling>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlgOnboardingScheduling<TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns PLG onboarding scheduling details for the specified Platform,
including the customer success meeting link, meeting datetime, and CEM information.
 */

export function useGetPlgOnboardingScheduling<TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlgOnboardingSchedulingQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPlgOnboardingSchedulingSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlgOnboardingSchedulingQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>> = ({ signal }) => getPlgOnboardingScheduling(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPlgOnboardingSchedulingSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>>
export type GetPlgOnboardingSchedulingSuspenseQueryError = ErrorType<void>


export function useGetPlgOnboardingSchedulingSuspense<TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlgOnboardingSchedulingSuspense<TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlgOnboardingSchedulingSuspense<TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns PLG onboarding scheduling details for the specified Platform,
including the customer success meeting link, meeting datetime, and CEM information.
 */

export function useGetPlgOnboardingSchedulingSuspense<TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlgOnboardingSchedulingSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Confirms a customer success meeting for a Platform after a Chilipiper booking.
 */
export const confirmCustomerSuccessMeeting = (
    platformId: string,
    associateCustomerSuccessMeetingDateTimeToPlatformRequest: AssociateCustomerSuccessMeetingDateTimeToPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-customer-success-meeting`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: associateCustomerSuccessMeetingDateTimeToPlatformRequest, signal
    },
      );
    }




export const getConfirmCustomerSuccessMeetingMutationKey = () => ['confirmCustomerSuccessMeeting'] as const;

export const getConfirmCustomerSuccessMeetingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>, TError,ConfirmCustomerSuccessMeetingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>, TError,ConfirmCustomerSuccessMeetingMutationVariables, TContext> => {

const mutationKey = getConfirmCustomerSuccessMeetingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>, ConfirmCustomerSuccessMeetingMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmCustomerSuccessMeeting(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmCustomerSuccessMeetingMutationResult = NonNullable<Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>>
    export type ConfirmCustomerSuccessMeetingMutationBody = AssociateCustomerSuccessMeetingDateTimeToPlatformRequest
    export type ConfirmCustomerSuccessMeetingMutationError = ErrorType<void>
    export type ConfirmCustomerSuccessMeetingMutationVariables = {platformId: string;data: AssociateCustomerSuccessMeetingDateTimeToPlatformRequest}

    /**
 * @summary Confirms a customer success meeting for a Platform after a Chilipiper booking.
 */
export const useConfirmCustomerSuccessMeeting = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>, TError,ConfirmCustomerSuccessMeetingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>,
        TError,
        ConfirmCustomerSuccessMeetingMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmCustomerSuccessMeetingMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns platform product subscription record (projection customer history and billing lifecycle) for the specified platform.
Requires authentication — use `GET /product-subscriptions` on RepeatMD.AdminApp.Controllers.Api.PlatformsAllowAnonymousController for the anonymous operational list.
 */
export const getPlatformProductSubscriptionRecord = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayPlatformProductSubscriptions>(
      {url: `/api/v1/platforms/${platformId}/platform-product-subscription`, method: 'GET', signal
    },
      );
    }




export const getGetPlatformProductSubscriptionRecordQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/platform-product-subscription`
    ] as const;
    }


export const getGetPlatformProductSubscriptionRecordQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformProductSubscriptionRecordQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>> = ({ signal }) => getPlatformProductSubscriptionRecord(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformProductSubscriptionRecordQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>>
export type GetPlatformProductSubscriptionRecordQueryError = ErrorType<unknown>


export function useGetPlatformProductSubscriptionRecord<TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>,
          TError,
          Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformProductSubscriptionRecord<TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>,
          TError,
          Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformProductSubscriptionRecord<TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns platform product subscription record (projection customer history and billing lifecycle) for the specified platform.
Requires authentication — use `GET /product-subscriptions` on RepeatMD.AdminApp.Controllers.Api.PlatformsAllowAnonymousController for the anonymous operational list.
 */

export function useGetPlatformProductSubscriptionRecord<TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformProductSubscriptionRecordQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPlatformProductSubscriptionRecordSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformProductSubscriptionRecordQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>> = ({ signal }) => getPlatformProductSubscriptionRecord(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPlatformProductSubscriptionRecordSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>>
export type GetPlatformProductSubscriptionRecordSuspenseQueryError = ErrorType<unknown>


export function useGetPlatformProductSubscriptionRecordSuspense<TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformProductSubscriptionRecordSuspense<TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformProductSubscriptionRecordSuspense<TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns platform product subscription record (projection customer history and billing lifecycle) for the specified platform.
Requires authentication — use `GET /product-subscriptions` on RepeatMD.AdminApp.Controllers.Api.PlatformsAllowAnonymousController for the anonymous operational list.
 */

export function useGetPlatformProductSubscriptionRecordSuspense<TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformProductSubscriptionRecordSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Initiates caller ID verification for a platform location's phone number.
 */
export const initiateCallerIdVerification = (
    platformId: string,
    locationId: string,
    initiateCallerIdVerificationForPlatformLocationRequest: InitiateCallerIdVerificationForPlatformLocationRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCallerIdVerificationInitiationReference>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/caller-id-verification/initiate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: initiateCallerIdVerificationForPlatformLocationRequest, signal
    },
      );
    }




export const getInitiateCallerIdVerificationMutationKey = () => ['initiateCallerIdVerification'] as const;

export const getInitiateCallerIdVerificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateCallerIdVerification>>, TError,InitiateCallerIdVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof initiateCallerIdVerification>>, TError,InitiateCallerIdVerificationMutationVariables, TContext> => {

const mutationKey = getInitiateCallerIdVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiateCallerIdVerification>>, InitiateCallerIdVerificationMutationVariables> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  initiateCallerIdVerification(platformId,locationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitiateCallerIdVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof initiateCallerIdVerification>>>
    export type InitiateCallerIdVerificationMutationBody = InitiateCallerIdVerificationForPlatformLocationRequest
    export type InitiateCallerIdVerificationMutationError = ErrorType<unknown>
    export type InitiateCallerIdVerificationMutationVariables = {platformId: string;locationId: string;data: InitiateCallerIdVerificationForPlatformLocationRequest}

    /**
 * @summary Initiates caller ID verification for a platform location's phone number.
 */
export const useInitiateCallerIdVerification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateCallerIdVerification>>, TError,InitiateCallerIdVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initiateCallerIdVerification>>,
        TError,
        InitiateCallerIdVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getInitiateCallerIdVerificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves the details of an initiated caller ID verification for a platform location.
 */
export const getCallerIdVerificationInitiationDetails = (
    platformId: string,
    callerIdVerificationId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCallerIdVerificationInitiatedForPlatformLocation>(
      {url: `/api/v1/platforms/${platformId}/caller-id-verification/${callerIdVerificationId}`, method: 'GET', signal
    },
      );
    }




export const getGetCallerIdVerificationInitiationDetailsQueryKey = (platformId: string,
    callerIdVerificationId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/caller-id-verification/${callerIdVerificationId}`
    ] as const;
    }


export const getGetCallerIdVerificationInitiationDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(platformId: string,
    callerIdVerificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCallerIdVerificationInitiationDetailsQueryKey(platformId,callerIdVerificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>> = ({ signal }) => getCallerIdVerificationInitiationDetails(platformId,callerIdVerificationId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined && callerIdVerificationId !== null && callerIdVerificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCallerIdVerificationInitiationDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>>
export type GetCallerIdVerificationInitiationDetailsQueryError = ErrorType<unknown>


export function useGetCallerIdVerificationInitiationDetails<TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    callerIdVerificationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>,
          TError,
          Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCallerIdVerificationInitiationDetails<TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    callerIdVerificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>,
          TError,
          Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCallerIdVerificationInitiationDetails<TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    callerIdVerificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the details of an initiated caller ID verification for a platform location.
 */

export function useGetCallerIdVerificationInitiationDetails<TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    callerIdVerificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCallerIdVerificationInitiationDetailsQueryOptions(platformId,callerIdVerificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCallerIdVerificationInitiationDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(platformId: string,
    callerIdVerificationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCallerIdVerificationInitiationDetailsQueryKey(platformId,callerIdVerificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>> = ({ signal }) => getCallerIdVerificationInitiationDetails(platformId,callerIdVerificationId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCallerIdVerificationInitiationDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>>
export type GetCallerIdVerificationInitiationDetailsSuspenseQueryError = ErrorType<unknown>


export function useGetCallerIdVerificationInitiationDetailsSuspense<TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    callerIdVerificationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCallerIdVerificationInitiationDetailsSuspense<TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    callerIdVerificationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCallerIdVerificationInitiationDetailsSuspense<TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    callerIdVerificationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the details of an initiated caller ID verification for a platform location.
 */

export function useGetCallerIdVerificationInitiationDetailsSuspense<TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    callerIdVerificationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCallerIdVerificationInitiationDetailsSuspenseQueryOptions(platformId,callerIdVerificationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Confirms a pending caller ID verification for a platform location.
 */
export const confirmCallerIdVerification = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/caller-id-verification/confirm`, method: 'POST', signal
    },
      );
    }




export const getConfirmCallerIdVerificationMutationKey = () => ['confirmCallerIdVerification'] as const;

export const getConfirmCallerIdVerificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCallerIdVerification>>, TError,ConfirmCallerIdVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmCallerIdVerification>>, TError,ConfirmCallerIdVerificationMutationVariables, TContext> => {

const mutationKey = getConfirmCallerIdVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmCallerIdVerification>>, ConfirmCallerIdVerificationMutationVariables> = (props) => {
          const {platformId,locationId} = props ?? {};

          return  confirmCallerIdVerification(platformId,locationId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmCallerIdVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof confirmCallerIdVerification>>>

    export type ConfirmCallerIdVerificationMutationError = ErrorType<unknown>
    export type ConfirmCallerIdVerificationMutationVariables = {platformId: string;locationId: string}

    /**
 * @summary Confirms a pending caller ID verification for a platform location.
 */
export const useConfirmCallerIdVerification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCallerIdVerification>>, TError,ConfirmCallerIdVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmCallerIdVerification>>,
        TError,
        ConfirmCallerIdVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmCallerIdVerificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Revokes the caller ID verification for a platform location.
 */
export const revokeCallerIdVerification = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/caller-id-verification`, method: 'DELETE', signal
    },
      );
    }




export const getRevokeCallerIdVerificationMutationKey = () => ['revokeCallerIdVerification'] as const;

export const getRevokeCallerIdVerificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeCallerIdVerification>>, TError,RevokeCallerIdVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeCallerIdVerification>>, TError,RevokeCallerIdVerificationMutationVariables, TContext> => {

const mutationKey = getRevokeCallerIdVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeCallerIdVerification>>, RevokeCallerIdVerificationMutationVariables> = (props) => {
          const {platformId,locationId} = props ?? {};

          return  revokeCallerIdVerification(platformId,locationId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeCallerIdVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof revokeCallerIdVerification>>>

    export type RevokeCallerIdVerificationMutationError = ErrorType<unknown>
    export type RevokeCallerIdVerificationMutationVariables = {platformId: string;locationId: string}

    /**
 * @summary Revokes the caller ID verification for a platform location.
 */
export const useRevokeCallerIdVerification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeCallerIdVerification>>, TError,RevokeCallerIdVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeCallerIdVerification>>,
        TError,
        RevokeCallerIdVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeCallerIdVerificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves the caller ID verification status for a platform location.
 */
export const getCallerIdVerificationStatus = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCallerIdVerificationStatusForPlatformLocation>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/caller-id-verification/status`, method: 'GET', signal
    },
      );
    }




export const getGetCallerIdVerificationStatusQueryKey = (platformId: string,
    locationId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/locations/${locationId}/caller-id-verification/status`
    ] as const;
    }


export const getGetCallerIdVerificationStatusQueryOptions = <TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(platformId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCallerIdVerificationStatusQueryKey(platformId,locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>> = ({ signal }) => getCallerIdVerificationStatus(platformId,locationId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined && locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCallerIdVerificationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>>
export type GetCallerIdVerificationStatusQueryError = ErrorType<unknown>


export function useGetCallerIdVerificationStatus<TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    locationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallerIdVerificationStatus>>,
          TError,
          Awaited<ReturnType<typeof getCallerIdVerificationStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCallerIdVerificationStatus<TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallerIdVerificationStatus>>,
          TError,
          Awaited<ReturnType<typeof getCallerIdVerificationStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCallerIdVerificationStatus<TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the caller ID verification status for a platform location.
 */

export function useGetCallerIdVerificationStatus<TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCallerIdVerificationStatusQueryOptions(platformId,locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCallerIdVerificationStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(platformId: string,
    locationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCallerIdVerificationStatusQueryKey(platformId,locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>> = ({ signal }) => getCallerIdVerificationStatus(platformId,locationId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCallerIdVerificationStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>>
export type GetCallerIdVerificationStatusSuspenseQueryError = ErrorType<unknown>


export function useGetCallerIdVerificationStatusSuspense<TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    locationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCallerIdVerificationStatusSuspense<TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCallerIdVerificationStatusSuspense<TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the caller ID verification status for a platform location.
 */

export function useGetCallerIdVerificationStatusSuspense<TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    locationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCallerIdVerificationStatusSuspenseQueryOptions(platformId,locationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the verified caller IDs for a platform.
 */
export const getVerifiedCallerIds = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayVerifiedCallerIdsForPlatform>(
      {url: `/api/v1/platforms/${platformId}/verified-caller-ids`, method: 'GET', signal
    },
      );
    }




export const getGetVerifiedCallerIdsQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/verified-caller-ids`
    ] as const;
    }


export const getGetVerifiedCallerIdsQueryOptions = <TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerifiedCallerIdsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifiedCallerIds>>> = ({ signal }) => getVerifiedCallerIds(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVerifiedCallerIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifiedCallerIds>>>
export type GetVerifiedCallerIdsQueryError = ErrorType<unknown>


export function useGetVerifiedCallerIds<TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifiedCallerIds>>,
          TError,
          Awaited<ReturnType<typeof getVerifiedCallerIds>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifiedCallerIds<TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifiedCallerIds>>,
          TError,
          Awaited<ReturnType<typeof getVerifiedCallerIds>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifiedCallerIds<TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the verified caller IDs for a platform.
 */

export function useGetVerifiedCallerIds<TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVerifiedCallerIdsQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetVerifiedCallerIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerifiedCallerIdsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifiedCallerIds>>> = ({ signal }) => getVerifiedCallerIds(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetVerifiedCallerIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifiedCallerIds>>>
export type GetVerifiedCallerIdsSuspenseQueryError = ErrorType<unknown>


export function useGetVerifiedCallerIdsSuspense<TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifiedCallerIdsSuspense<TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifiedCallerIdsSuspense<TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the verified caller IDs for a platform.
 */

export function useGetVerifiedCallerIdsSuspense<TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVerifiedCallerIdsSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Switches a platform to a different Stripe region.
 */
export const _switch = (
    platformId: string,
    stripeRegion: string,
 signal?: AbortSignal
) => {


      return customAxios<PlatformSwitchedToStripeRegionEvent>(
      {url: `/api/v1/platforms/${platformId}/switch-stripe-region/${stripeRegion}`, method: 'POST', signal
    },
      );
    }




export const getSwitchMutationKey = () => ['_switch'] as const;

export const getSwitchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _switch>>, TError,_SwitchMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof _switch>>, TError,_SwitchMutationVariables, TContext> => {

const mutationKey = getSwitchMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof _switch>>, _SwitchMutationVariables> = (props) => {
          const {platformId,stripeRegion} = props ?? {};

          return  _switch(platformId,stripeRegion,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type _SwitchMutationResult = NonNullable<Awaited<ReturnType<typeof _switch>>>

    export type _SwitchMutationError = ErrorType<unknown>
    export type _SwitchMutationVariables = {platformId: string;stripeRegion: string}

    /**
 * @summary Switches a platform to a different Stripe region.
 */
export const useSwitch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _switch>>, TError,_SwitchMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof _switch>>,
        TError,
        _SwitchMutationVariables,
        TContext
      > => {
      return useMutation(getSwitchMutationOptions(options), queryClient);
    }
    /**
 * @summary Sets the data privacy region for a platform.
 */
export const setDataPrivacyRegionForPlatform = (
    platformId: string,
    setDataPrivacyRegionForPlatformRequest: SetDataPrivacyRegionForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/data-privacy-region`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setDataPrivacyRegionForPlatformRequest, signal
    },
      );
    }




export const getSetDataPrivacyRegionForPlatformMutationKey = () => ['setDataPrivacyRegionForPlatform'] as const;

export const getSetDataPrivacyRegionForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>, TError,SetDataPrivacyRegionForPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>, TError,SetDataPrivacyRegionForPlatformMutationVariables, TContext> => {

const mutationKey = getSetDataPrivacyRegionForPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>, SetDataPrivacyRegionForPlatformMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  setDataPrivacyRegionForPlatform(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDataPrivacyRegionForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>>
    export type SetDataPrivacyRegionForPlatformMutationBody = SetDataPrivacyRegionForPlatformRequest
    export type SetDataPrivacyRegionForPlatformMutationError = ErrorType<unknown>
    export type SetDataPrivacyRegionForPlatformMutationVariables = {platformId: string;data: SetDataPrivacyRegionForPlatformRequest}

    /**
 * @summary Sets the data privacy region for a platform.
 */
export const useSetDataPrivacyRegionForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>, TError,SetDataPrivacyRegionForPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>,
        TError,
        SetDataPrivacyRegionForPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getSetDataPrivacyRegionForPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Enables gift cards for a platform.
 */
export const enableGiftCardsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/enable-gift-cards`, method: 'PUT', signal
    },
      );
    }




export const getEnableGiftCardsForPlatformMutationKey = () => ['enableGiftCardsForPlatform'] as const;

export const getEnableGiftCardsForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableGiftCardsForPlatform>>, TError,EnableGiftCardsForPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableGiftCardsForPlatform>>, TError,EnableGiftCardsForPlatformMutationVariables, TContext> => {

const mutationKey = getEnableGiftCardsForPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableGiftCardsForPlatform>>, EnableGiftCardsForPlatformMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  enableGiftCardsForPlatform(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableGiftCardsForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof enableGiftCardsForPlatform>>>

    export type EnableGiftCardsForPlatformMutationError = ErrorType<unknown>
    export type EnableGiftCardsForPlatformMutationVariables = {platformId: string}

    /**
 * @summary Enables gift cards for a platform.
 */
export const useEnableGiftCardsForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableGiftCardsForPlatform>>, TError,EnableGiftCardsForPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableGiftCardsForPlatform>>,
        TError,
        EnableGiftCardsForPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getEnableGiftCardsForPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Disables gift cards for a platform.
 */
export const disableGiftCardsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/disable-gift-cards`, method: 'PUT', signal
    },
      );
    }




export const getDisableGiftCardsForPlatformMutationKey = () => ['disableGiftCardsForPlatform'] as const;

export const getDisableGiftCardsForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableGiftCardsForPlatform>>, TError,DisableGiftCardsForPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableGiftCardsForPlatform>>, TError,DisableGiftCardsForPlatformMutationVariables, TContext> => {

const mutationKey = getDisableGiftCardsForPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableGiftCardsForPlatform>>, DisableGiftCardsForPlatformMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  disableGiftCardsForPlatform(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableGiftCardsForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof disableGiftCardsForPlatform>>>

    export type DisableGiftCardsForPlatformMutationError = ErrorType<unknown>
    export type DisableGiftCardsForPlatformMutationVariables = {platformId: string}

    /**
 * @summary Disables gift cards for a platform.
 */
export const useDisableGiftCardsForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableGiftCardsForPlatform>>, TError,DisableGiftCardsForPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableGiftCardsForPlatform>>,
        TError,
        DisableGiftCardsForPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getDisableGiftCardsForPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Enables referral rewards for a platform.
 */
export const enableReferralRewardsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/enable-referral-rewards`, method: 'PUT', signal
    },
      );
    }




export const getEnableReferralRewardsForPlatformMutationKey = () => ['enableReferralRewardsForPlatform'] as const;

export const getEnableReferralRewardsForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>, TError,EnableReferralRewardsForPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>, TError,EnableReferralRewardsForPlatformMutationVariables, TContext> => {

const mutationKey = getEnableReferralRewardsForPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>, EnableReferralRewardsForPlatformMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  enableReferralRewardsForPlatform(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableReferralRewardsForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>>

    export type EnableReferralRewardsForPlatformMutationError = ErrorType<unknown>
    export type EnableReferralRewardsForPlatformMutationVariables = {platformId: string}

    /**
 * @summary Enables referral rewards for a platform.
 */
export const useEnableReferralRewardsForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>, TError,EnableReferralRewardsForPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>,
        TError,
        EnableReferralRewardsForPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getEnableReferralRewardsForPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Disables referral rewards for a platform.
 */
export const disableReferralRewardsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/disable-referral-rewards`, method: 'PUT', signal
    },
      );
    }




export const getDisableReferralRewardsForPlatformMutationKey = () => ['disableReferralRewardsForPlatform'] as const;

export const getDisableReferralRewardsForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>, TError,DisableReferralRewardsForPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>, TError,DisableReferralRewardsForPlatformMutationVariables, TContext> => {

const mutationKey = getDisableReferralRewardsForPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>, DisableReferralRewardsForPlatformMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  disableReferralRewardsForPlatform(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableReferralRewardsForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>>

    export type DisableReferralRewardsForPlatformMutationError = ErrorType<unknown>
    export type DisableReferralRewardsForPlatformMutationVariables = {platformId: string}

    /**
 * @summary Disables referral rewards for a platform.
 */
export const useDisableReferralRewardsForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>, TError,DisableReferralRewardsForPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>,
        TError,
        DisableReferralRewardsForPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getDisableReferralRewardsForPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Schedule retail products to be visible on marketplace
 */
export const scheduleProductCatalogVisibilityOnMarketplace = (
    platformId: string,
    scheduleRetailProductsVisibilityOnMarketplaceRequest: ScheduleRetailProductsVisibilityOnMarketplaceRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/schedule-product-catalog-visible-on-marketplace`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: scheduleRetailProductsVisibilityOnMarketplaceRequest, signal
    },
      );
    }




export const getScheduleProductCatalogVisibilityOnMarketplaceMutationKey = () => ['scheduleProductCatalogVisibilityOnMarketplace'] as const;

export const getScheduleProductCatalogVisibilityOnMarketplaceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>, TError,ScheduleProductCatalogVisibilityOnMarketplaceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>, TError,ScheduleProductCatalogVisibilityOnMarketplaceMutationVariables, TContext> => {

const mutationKey = getScheduleProductCatalogVisibilityOnMarketplaceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>, ScheduleProductCatalogVisibilityOnMarketplaceMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  scheduleProductCatalogVisibilityOnMarketplace(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleProductCatalogVisibilityOnMarketplaceMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>>
    export type ScheduleProductCatalogVisibilityOnMarketplaceMutationBody = ScheduleRetailProductsVisibilityOnMarketplaceRequest
    export type ScheduleProductCatalogVisibilityOnMarketplaceMutationError = ErrorType<unknown>
    export type ScheduleProductCatalogVisibilityOnMarketplaceMutationVariables = {platformId: string;data: ScheduleRetailProductsVisibilityOnMarketplaceRequest}

    /**
 * @summary Schedule retail products to be visible on marketplace
 */
export const useScheduleProductCatalogVisibilityOnMarketplace = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>, TError,ScheduleProductCatalogVisibilityOnMarketplaceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>,
        TError,
        ScheduleProductCatalogVisibilityOnMarketplaceMutationVariables,
        TContext
      > => {
      return useMutation(getScheduleProductCatalogVisibilityOnMarketplaceMutationOptions(options), queryClient);
    }
    /**
 * @summary Schedule retail products to be visible on marketplace
 */
export const productCatalogMarketplaceVisibilitySchedule = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayRetailProductsMarketplaceVisibilitySchedule>(
      {url: `/api/v1/platforms/${platformId}/product-catalog-marketplace-visibility-schedule`, method: 'GET', signal
    },
      );
    }




export const getProductCatalogMarketplaceVisibilityScheduleQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/product-catalog-marketplace-visibility-schedule`
    ] as const;
    }


export const getProductCatalogMarketplaceVisibilityScheduleQueryOptions = <TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductCatalogMarketplaceVisibilityScheduleQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>> = ({ signal }) => productCatalogMarketplaceVisibilitySchedule(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductCatalogMarketplaceVisibilityScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>>
export type ProductCatalogMarketplaceVisibilityScheduleQueryError = ErrorType<unknown>


export function useProductCatalogMarketplaceVisibilitySchedule<TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>,
          TError,
          Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductCatalogMarketplaceVisibilitySchedule<TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>,
          TError,
          Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductCatalogMarketplaceVisibilitySchedule<TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Schedule retail products to be visible on marketplace
 */

export function useProductCatalogMarketplaceVisibilitySchedule<TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductCatalogMarketplaceVisibilityScheduleQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProductCatalogMarketplaceVisibilityScheduleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductCatalogMarketplaceVisibilityScheduleQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>> = ({ signal }) => productCatalogMarketplaceVisibilitySchedule(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ProductCatalogMarketplaceVisibilityScheduleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>>
export type ProductCatalogMarketplaceVisibilityScheduleSuspenseQueryError = ErrorType<unknown>


export function useProductCatalogMarketplaceVisibilityScheduleSuspense<TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductCatalogMarketplaceVisibilityScheduleSuspense<TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductCatalogMarketplaceVisibilityScheduleSuspense<TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Schedule retail products to be visible on marketplace
 */

export function useProductCatalogMarketplaceVisibilityScheduleSuspense<TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductCatalogMarketplaceVisibilityScheduleSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Hide retail products from the marketplace
 */
export const hideProductCatalogFromMarketplace = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/hide-product-catalog-from-marketplace`, method: 'PUT', signal
    },
      );
    }




export const getHideProductCatalogFromMarketplaceMutationKey = () => ['hideProductCatalogFromMarketplace'] as const;

export const getHideProductCatalogFromMarketplaceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>, TError,HideProductCatalogFromMarketplaceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>, TError,HideProductCatalogFromMarketplaceMutationVariables, TContext> => {

const mutationKey = getHideProductCatalogFromMarketplaceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>, HideProductCatalogFromMarketplaceMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  hideProductCatalogFromMarketplace(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HideProductCatalogFromMarketplaceMutationResult = NonNullable<Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>>

    export type HideProductCatalogFromMarketplaceMutationError = ErrorType<unknown>
    export type HideProductCatalogFromMarketplaceMutationVariables = {platformId: string}

    /**
 * @summary Hide retail products from the marketplace
 */
export const useHideProductCatalogFromMarketplace = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>, TError,HideProductCatalogFromMarketplaceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>,
        TError,
        HideProductCatalogFromMarketplaceMutationVariables,
        TContext
      > => {
      return useMutation(getHideProductCatalogFromMarketplaceMutationOptions(options), queryClient);
    }
    /**
 * @summary Schedule SkinDrop to be visible on marketplace
 */
export const scheduleSkinDropVisibilityOnMarketplace = (
    platformId: string,
    scheduleSkinDropVisibilityOnMarketplaceRequest: ScheduleSkinDropVisibilityOnMarketplaceRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/schedule-skindrop-visible-on-marketplace`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: scheduleSkinDropVisibilityOnMarketplaceRequest, signal
    },
      );
    }




export const getScheduleSkinDropVisibilityOnMarketplaceMutationKey = () => ['scheduleSkinDropVisibilityOnMarketplace'] as const;

export const getScheduleSkinDropVisibilityOnMarketplaceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>, TError,ScheduleSkinDropVisibilityOnMarketplaceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>, TError,ScheduleSkinDropVisibilityOnMarketplaceMutationVariables, TContext> => {

const mutationKey = getScheduleSkinDropVisibilityOnMarketplaceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>, ScheduleSkinDropVisibilityOnMarketplaceMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  scheduleSkinDropVisibilityOnMarketplace(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleSkinDropVisibilityOnMarketplaceMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>>
    export type ScheduleSkinDropVisibilityOnMarketplaceMutationBody = ScheduleSkinDropVisibilityOnMarketplaceRequest
    export type ScheduleSkinDropVisibilityOnMarketplaceMutationError = ErrorType<unknown>
    export type ScheduleSkinDropVisibilityOnMarketplaceMutationVariables = {platformId: string;data: ScheduleSkinDropVisibilityOnMarketplaceRequest}

    /**
 * @summary Schedule SkinDrop to be visible on marketplace
 */
export const useScheduleSkinDropVisibilityOnMarketplace = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>, TError,ScheduleSkinDropVisibilityOnMarketplaceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>,
        TError,
        ScheduleSkinDropVisibilityOnMarketplaceMutationVariables,
        TContext
      > => {
      return useMutation(getScheduleSkinDropVisibilityOnMarketplaceMutationOptions(options), queryClient);
    }
    /**
 * @summary Get SkinDrop marketplace visibility schedule
 */
export const skinDropMarketplaceVisibilitySchedule = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplaySkinDropMarketplaceVisibilitySchedule>(
      {url: `/api/v1/platforms/${platformId}/skindrop-marketplace-visibility-schedule`, method: 'GET', signal
    },
      );
    }




export const getSkinDropMarketplaceVisibilityScheduleQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/skindrop-marketplace-visibility-schedule`
    ] as const;
    }


export const getSkinDropMarketplaceVisibilityScheduleQueryOptions = <TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkinDropMarketplaceVisibilityScheduleQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>> = ({ signal }) => skinDropMarketplaceVisibilitySchedule(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkinDropMarketplaceVisibilityScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>>
export type SkinDropMarketplaceVisibilityScheduleQueryError = ErrorType<unknown>


export function useSkinDropMarketplaceVisibilitySchedule<TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>,
          TError,
          Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkinDropMarketplaceVisibilitySchedule<TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>,
          TError,
          Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkinDropMarketplaceVisibilitySchedule<TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get SkinDrop marketplace visibility schedule
 */

export function useSkinDropMarketplaceVisibilitySchedule<TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkinDropMarketplaceVisibilityScheduleQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSkinDropMarketplaceVisibilityScheduleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkinDropMarketplaceVisibilityScheduleQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>> = ({ signal }) => skinDropMarketplaceVisibilitySchedule(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type SkinDropMarketplaceVisibilityScheduleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>>
export type SkinDropMarketplaceVisibilityScheduleSuspenseQueryError = ErrorType<unknown>


export function useSkinDropMarketplaceVisibilityScheduleSuspense<TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkinDropMarketplaceVisibilityScheduleSuspense<TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkinDropMarketplaceVisibilityScheduleSuspense<TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get SkinDrop marketplace visibility schedule
 */

export function useSkinDropMarketplaceVisibilityScheduleSuspense<TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkinDropMarketplaceVisibilityScheduleSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Hide SkinDrop from the marketplace
 */
export const hideSkinDropFromMarketplace = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/hide-skindrop-from-marketplace`, method: 'PUT', signal
    },
      );
    }




export const getHideSkinDropFromMarketplaceMutationKey = () => ['hideSkinDropFromMarketplace'] as const;

export const getHideSkinDropFromMarketplaceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>, TError,HideSkinDropFromMarketplaceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>, TError,HideSkinDropFromMarketplaceMutationVariables, TContext> => {

const mutationKey = getHideSkinDropFromMarketplaceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>, HideSkinDropFromMarketplaceMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  hideSkinDropFromMarketplace(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HideSkinDropFromMarketplaceMutationResult = NonNullable<Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>>

    export type HideSkinDropFromMarketplaceMutationError = ErrorType<unknown>
    export type HideSkinDropFromMarketplaceMutationVariables = {platformId: string}

    /**
 * @summary Hide SkinDrop from the marketplace
 */
export const useHideSkinDropFromMarketplace = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>, TError,HideSkinDropFromMarketplaceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>,
        TError,
        HideSkinDropFromMarketplaceMutationVariables,
        TContext
      > => {
      return useMutation(getHideSkinDropFromMarketplaceMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves all repeat cash transactions for a specific platform
 */
export const getRepeatCashTransactionsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayRepeatCashTransactionsForPlatform>(
      {url: `/api/v1/platforms/${platformId}/repeat-cash-transactions`, method: 'GET', signal
    },
      );
    }




export const getGetRepeatCashTransactionsForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/repeat-cash-transactions`
    ] as const;
    }


export const getGetRepeatCashTransactionsForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRepeatCashTransactionsForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>> = ({ signal }) => getRepeatCashTransactionsForPlatform(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRepeatCashTransactionsForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>>
export type GetRepeatCashTransactionsForPlatformQueryError = ErrorType<unknown>


export function useGetRepeatCashTransactionsForPlatform<TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRepeatCashTransactionsForPlatform<TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRepeatCashTransactionsForPlatform<TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all repeat cash transactions for a specific platform
 */

export function useGetRepeatCashTransactionsForPlatform<TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRepeatCashTransactionsForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRepeatCashTransactionsForPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRepeatCashTransactionsForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>> = ({ signal }) => getRepeatCashTransactionsForPlatform(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRepeatCashTransactionsForPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>>
export type GetRepeatCashTransactionsForPlatformSuspenseQueryError = ErrorType<unknown>


export function useGetRepeatCashTransactionsForPlatformSuspense<TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRepeatCashTransactionsForPlatformSuspense<TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRepeatCashTransactionsForPlatformSuspense<TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all repeat cash transactions for a specific platform
 */

export function useGetRepeatCashTransactionsForPlatformSuspense<TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRepeatCashTransactionsForPlatformSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves every client's current RepeatCash balance on a platform, split into paid and gifted
 */
export const getRepeatCashBalancesForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayRepeatCashBalancesForPlatform>(
      {url: `/api/v1/platforms/${platformId}/repeat-cash-balances`, method: 'GET', signal
    },
      );
    }




export const getGetRepeatCashBalancesForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/repeat-cash-balances`
    ] as const;
    }


export const getGetRepeatCashBalancesForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRepeatCashBalancesForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>> = ({ signal }) => getRepeatCashBalancesForPlatform(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRepeatCashBalancesForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>>
export type GetRepeatCashBalancesForPlatformQueryError = ErrorType<unknown>


export function useGetRepeatCashBalancesForPlatform<TData = Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRepeatCashBalancesForPlatform<TData = Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRepeatCashBalancesForPlatform<TData = Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves every client's current RepeatCash balance on a platform, split into paid and gifted
 */

export function useGetRepeatCashBalancesForPlatform<TData = Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRepeatCashBalancesForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRepeatCashBalancesForPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRepeatCashBalancesForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>> = ({ signal }) => getRepeatCashBalancesForPlatform(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRepeatCashBalancesForPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>>
export type GetRepeatCashBalancesForPlatformSuspenseQueryError = ErrorType<unknown>


export function useGetRepeatCashBalancesForPlatformSuspense<TData = Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRepeatCashBalancesForPlatformSuspense<TData = Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRepeatCashBalancesForPlatformSuspense<TData = Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves every client's current RepeatCash balance on a platform, split into paid and gifted
 */

export function useGetRepeatCashBalancesForPlatformSuspense<TData = Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRepeatCashBalancesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRepeatCashBalancesForPlatformSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves all disputes for a specific platform
 */
export const getDisputesForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayDisputesForPlatform>(
      {url: `/api/v1/platforms/${platformId}/disputes`, method: 'GET', signal
    },
      );
    }




export const getGetDisputesForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/disputes`
    ] as const;
    }


export const getGetDisputesForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDisputesForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDisputesForPlatform>>> = ({ signal }) => getDisputesForPlatform(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDisputesForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getDisputesForPlatform>>>
export type GetDisputesForPlatformQueryError = ErrorType<unknown>


export function useGetDisputesForPlatform<TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisputesForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getDisputesForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDisputesForPlatform<TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisputesForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getDisputesForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDisputesForPlatform<TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all disputes for a specific platform
 */

export function useGetDisputesForPlatform<TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDisputesForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDisputesForPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDisputesForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDisputesForPlatform>>> = ({ signal }) => getDisputesForPlatform(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDisputesForPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDisputesForPlatform>>>
export type GetDisputesForPlatformSuspenseQueryError = ErrorType<unknown>


export function useGetDisputesForPlatformSuspense<TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDisputesForPlatformSuspense<TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDisputesForPlatformSuspense<TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all disputes for a specific platform
 */

export function useGetDisputesForPlatformSuspense<TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDisputesForPlatformSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the dispute details
 */
export const getDisputeDetails = (
    platformId: string,
    disputeId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayDisputeDetails>(
      {url: `/api/v1/platforms/${platformId}/dispute/${disputeId}`, method: 'GET', signal
    },
      );
    }




export const getGetDisputeDetailsQueryKey = (platformId: string,
    disputeId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/dispute/${disputeId}`
    ] as const;
    }


export const getGetDisputeDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(platformId: string,
    disputeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDisputeDetailsQueryKey(platformId,disputeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDisputeDetails>>> = ({ signal }) => getDisputeDetails(platformId,disputeId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined && disputeId !== null && disputeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDisputeDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getDisputeDetails>>>
export type GetDisputeDetailsQueryError = ErrorType<unknown>


export function useGetDisputeDetails<TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    disputeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisputeDetails>>,
          TError,
          Awaited<ReturnType<typeof getDisputeDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDisputeDetails<TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    disputeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisputeDetails>>,
          TError,
          Awaited<ReturnType<typeof getDisputeDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDisputeDetails<TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    disputeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the dispute details
 */

export function useGetDisputeDetails<TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    disputeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDisputeDetailsQueryOptions(platformId,disputeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDisputeDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(platformId: string,
    disputeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDisputeDetailsQueryKey(platformId,disputeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDisputeDetails>>> = ({ signal }) => getDisputeDetails(platformId,disputeId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDisputeDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDisputeDetails>>>
export type GetDisputeDetailsSuspenseQueryError = ErrorType<unknown>


export function useGetDisputeDetailsSuspense<TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    disputeId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDisputeDetailsSuspense<TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    disputeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDisputeDetailsSuspense<TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    disputeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the dispute details
 */

export function useGetDisputeDetailsSuspense<TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    disputeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDisputeDetailsSuspenseQueryOptions(platformId,disputeId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Enables automatic payment enforcement for a platform.
 */
export const enableAutomaticPaymentEnforcementForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/enable-automatic-payment-enforcement`, method: 'PUT', signal
    },
      );
    }




export const getEnableAutomaticPaymentEnforcementForPlatformMutationKey = () => ['enableAutomaticPaymentEnforcementForPlatform'] as const;

export const getEnableAutomaticPaymentEnforcementForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>, TError,EnableAutomaticPaymentEnforcementForPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>, TError,EnableAutomaticPaymentEnforcementForPlatformMutationVariables, TContext> => {

const mutationKey = getEnableAutomaticPaymentEnforcementForPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>, EnableAutomaticPaymentEnforcementForPlatformMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  enableAutomaticPaymentEnforcementForPlatform(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAutomaticPaymentEnforcementForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>>

    export type EnableAutomaticPaymentEnforcementForPlatformMutationError = ErrorType<unknown>
    export type EnableAutomaticPaymentEnforcementForPlatformMutationVariables = {platformId: string}

    /**
 * @summary Enables automatic payment enforcement for a platform.
 */
export const useEnableAutomaticPaymentEnforcementForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>, TError,EnableAutomaticPaymentEnforcementForPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>,
        TError,
        EnableAutomaticPaymentEnforcementForPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getEnableAutomaticPaymentEnforcementForPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Disables automatic payment enforcement for a platform.
 */
export const disableAutomaticPaymentEnforcementForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/disable-automatic-payment-enforcement`, method: 'PUT', signal
    },
      );
    }




export const getDisableAutomaticPaymentEnforcementForPlatformMutationKey = () => ['disableAutomaticPaymentEnforcementForPlatform'] as const;

export const getDisableAutomaticPaymentEnforcementForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>, TError,DisableAutomaticPaymentEnforcementForPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>, TError,DisableAutomaticPaymentEnforcementForPlatformMutationVariables, TContext> => {

const mutationKey = getDisableAutomaticPaymentEnforcementForPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>, DisableAutomaticPaymentEnforcementForPlatformMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  disableAutomaticPaymentEnforcementForPlatform(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableAutomaticPaymentEnforcementForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>>

    export type DisableAutomaticPaymentEnforcementForPlatformMutationError = ErrorType<unknown>
    export type DisableAutomaticPaymentEnforcementForPlatformMutationVariables = {platformId: string}

    /**
 * @summary Disables automatic payment enforcement for a platform.
 */
export const useDisableAutomaticPaymentEnforcementForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>, TError,DisableAutomaticPaymentEnforcementForPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>,
        TError,
        DisableAutomaticPaymentEnforcementForPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getDisableAutomaticPaymentEnforcementForPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves whether automatic payment enforcement is enabled for a platform.
 */
export const getAutomaticPaymentEnforcementStatus = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<boolean>(
      {url: `/api/v1/platforms/${platformId}/automatic-payment-enforcement-status`, method: 'GET', signal
    },
      );
    }




export const getGetAutomaticPaymentEnforcementStatusQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/automatic-payment-enforcement-status`
    ] as const;
    }


export const getGetAutomaticPaymentEnforcementStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAutomaticPaymentEnforcementStatusQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>> = ({ signal }) => getAutomaticPaymentEnforcementStatus(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAutomaticPaymentEnforcementStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>>
export type GetAutomaticPaymentEnforcementStatusQueryError = ErrorType<unknown>


export function useGetAutomaticPaymentEnforcementStatus<TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>,
          TError,
          Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAutomaticPaymentEnforcementStatus<TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>,
          TError,
          Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAutomaticPaymentEnforcementStatus<TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves whether automatic payment enforcement is enabled for a platform.
 */

export function useGetAutomaticPaymentEnforcementStatus<TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAutomaticPaymentEnforcementStatusQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAutomaticPaymentEnforcementStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAutomaticPaymentEnforcementStatusQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>> = ({ signal }) => getAutomaticPaymentEnforcementStatus(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAutomaticPaymentEnforcementStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>>
export type GetAutomaticPaymentEnforcementStatusSuspenseQueryError = ErrorType<unknown>


export function useGetAutomaticPaymentEnforcementStatusSuspense<TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAutomaticPaymentEnforcementStatusSuspense<TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAutomaticPaymentEnforcementStatusSuspense<TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves whether automatic payment enforcement is enabled for a platform.
 */

export function useGetAutomaticPaymentEnforcementStatusSuspense<TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAutomaticPaymentEnforcementStatusSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Initiates a practice catalog data import for a platform.
 */
export const initiatePracticeCatalogDataImport = (
    platformId: string,
    initiatePracticeCatalogDataImportBody: InitiatePracticeCatalogDataImportBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(initiatePracticeCatalogDataImportBody.jsonPayload !== undefined) {
 formData.append(`jsonPayload`, initiatePracticeCatalogDataImportBody.jsonPayload);
 }
if(initiatePracticeCatalogDataImportBody.files !== undefined) {
 initiatePracticeCatalogDataImportBody.files.forEach(value => formData.append(`files`, value));
 }

      return customAxios<string>(
      {url: `/api/v1/platforms/${platformId}/catalog/import`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getInitiatePracticeCatalogDataImportMutationKey = () => ['initiatePracticeCatalogDataImport'] as const;

export const getInitiatePracticeCatalogDataImportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>, TError,InitiatePracticeCatalogDataImportMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>, TError,InitiatePracticeCatalogDataImportMutationVariables, TContext> => {

const mutationKey = getInitiatePracticeCatalogDataImportMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>, InitiatePracticeCatalogDataImportMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  initiatePracticeCatalogDataImport(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitiatePracticeCatalogDataImportMutationResult = NonNullable<Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>>
    export type InitiatePracticeCatalogDataImportMutationBody = InitiatePracticeCatalogDataImportBody
    export type InitiatePracticeCatalogDataImportMutationError = ErrorType<void>
    export type InitiatePracticeCatalogDataImportMutationVariables = {platformId: string;data: InitiatePracticeCatalogDataImportBody}

    /**
 * @summary Initiates a practice catalog data import for a platform.
 */
export const useInitiatePracticeCatalogDataImport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>, TError,InitiatePracticeCatalogDataImportMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>,
        TError,
        InitiatePracticeCatalogDataImportMutationVariables,
        TContext
      > => {
      return useMutation(getInitiatePracticeCatalogDataImportMutationOptions(options), queryClient);
    }
    /**
 * @summary Creates a single draft treatment from structured "basics" (name, description, price, quantity, and an
optional image) by running them through the catalog importer's AI enrichment pipeline (concern/area
tagging, media-library image matching, unit-type resolution). Intended for agent-driven flows (Fin).
Returns immediately with the import id; the enriched draft is created asynchronously. When a callback
URL and conversation id are supplied, the backend POSTs a completion notification to that URL so a
paused Fin "Wait for webhook" workflow can resume.
 */
export const createTreatmentFromCatalog = (
    platformId: string,
    createTreatmentFromCatalogRequest: CreateTreatmentFromCatalogRequest,
 signal?: AbortSignal
) => {


      return customAxios<string>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/treatment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTreatmentFromCatalogRequest, signal
    },
      );
    }




export const getCreateTreatmentFromCatalogMutationKey = () => ['createTreatmentFromCatalog'] as const;

export const getCreateTreatmentFromCatalogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTreatmentFromCatalog>>, TError,CreateTreatmentFromCatalogMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTreatmentFromCatalog>>, TError,CreateTreatmentFromCatalogMutationVariables, TContext> => {

const mutationKey = getCreateTreatmentFromCatalogMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTreatmentFromCatalog>>, CreateTreatmentFromCatalogMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  createTreatmentFromCatalog(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTreatmentFromCatalogMutationResult = NonNullable<Awaited<ReturnType<typeof createTreatmentFromCatalog>>>
    export type CreateTreatmentFromCatalogMutationBody = CreateTreatmentFromCatalogRequest
    export type CreateTreatmentFromCatalogMutationError = ErrorType<unknown>
    export type CreateTreatmentFromCatalogMutationVariables = {platformId: string;data: CreateTreatmentFromCatalogRequest}

    /**
 * @summary Creates a single draft treatment from structured "basics" (name, description, price, quantity, and an
optional image) by running them through the catalog importer's AI enrichment pipeline (concern/area
tagging, media-library image matching, unit-type resolution). Intended for agent-driven flows (Fin).
Returns immediately with the import id; the enriched draft is created asynchronously. When a callback
URL and conversation id are supplied, the backend POSTs a completion notification to that URL so a
paused Fin "Wait for webhook" workflow can resume.
 */
export const useCreateTreatmentFromCatalog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTreatmentFromCatalog>>, TError,CreateTreatmentFromCatalogMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTreatmentFromCatalog>>,
        TError,
        CreateTreatmentFromCatalogMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTreatmentFromCatalogMutationOptions(options), queryClient);
    }
    /**
 * @summary Creates a single draft package from structured "basics" (name, price, an optional description/image, and
the included treatments — each a name + quantity) by running them through the catalog importer's AI
enrichment pipeline (concern/area tagging, media-library image matching, unit-type resolution). Intended
for agent-driven flows (Fin). The included treatments are created as inline package-scoped products.
A package requires at least two different included treatments (the catalog AI demotes single-treatment
bundles to treatment pricing). Returns immediately with the import id; the enriched draft is created
asynchronously. When a callback URL and conversation id are supplied, the backend POSTs a completion
notification to that URL so a paused Fin "Wait for webhook" workflow can resume.
 */
export const createPackageFromCatalog = (
    platformId: string,
    createPackageFromCatalogRequest: CreatePackageFromCatalogRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayInitiatedPackageCatalogImportResponse>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/package`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPackageFromCatalogRequest, signal
    },
      );
    }




export const getCreatePackageFromCatalogMutationKey = () => ['createPackageFromCatalog'] as const;

export const getCreatePackageFromCatalogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPackageFromCatalog>>, TError,CreatePackageFromCatalogMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPackageFromCatalog>>, TError,CreatePackageFromCatalogMutationVariables, TContext> => {

const mutationKey = getCreatePackageFromCatalogMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPackageFromCatalog>>, CreatePackageFromCatalogMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  createPackageFromCatalog(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePackageFromCatalogMutationResult = NonNullable<Awaited<ReturnType<typeof createPackageFromCatalog>>>
    export type CreatePackageFromCatalogMutationBody = CreatePackageFromCatalogRequest
    export type CreatePackageFromCatalogMutationError = ErrorType<unknown>
    export type CreatePackageFromCatalogMutationVariables = {platformId: string;data: CreatePackageFromCatalogRequest}

    /**
 * @summary Creates a single draft package from structured "basics" (name, price, an optional description/image, and
the included treatments — each a name + quantity) by running them through the catalog importer's AI
enrichment pipeline (concern/area tagging, media-library image matching, unit-type resolution). Intended
for agent-driven flows (Fin). The included treatments are created as inline package-scoped products.
A package requires at least two different included treatments (the catalog AI demotes single-treatment
bundles to treatment pricing). Returns immediately with the import id; the enriched draft is created
asynchronously. When a callback URL and conversation id are supplied, the backend POSTs a completion
notification to that URL so a paused Fin "Wait for webhook" workflow can resume.
 */
export const useCreatePackageFromCatalog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPackageFromCatalog>>, TError,CreatePackageFromCatalogMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPackageFromCatalog>>,
        TError,
        CreatePackageFromCatalogMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePackageFromCatalogMutationOptions(options), queryClient);
    }
    /**
 * @summary Creates a single draft membership from structured "basics" (name, monthly price, and optional
commitment, included services, discounts, and description) by running them through the catalog
importer's AI enrichment pipeline plus a chained generation step that resolves the included services
and discounts by name against the platform's active catalog. Intended for agent-driven flows (Fin).
Only name and monthly price are required. Returns immediately with the import id; the enriched draft
is created asynchronously. When a callback URL and conversation id are supplied, the backend POSTs a
completion notification to that URL so a paused Fin "Wait for webhook" workflow can resume.
 */
export const createMembershipFromCatalog = (
    platformId: string,
    createMembershipFromCatalogRequest: CreateMembershipFromCatalogRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayInitiatedMembershipCatalogImportResponse>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/membership`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMembershipFromCatalogRequest, signal
    },
      );
    }




export const getCreateMembershipFromCatalogMutationKey = () => ['createMembershipFromCatalog'] as const;

export const getCreateMembershipFromCatalogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMembershipFromCatalog>>, TError,CreateMembershipFromCatalogMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMembershipFromCatalog>>, TError,CreateMembershipFromCatalogMutationVariables, TContext> => {

const mutationKey = getCreateMembershipFromCatalogMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMembershipFromCatalog>>, CreateMembershipFromCatalogMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  createMembershipFromCatalog(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMembershipFromCatalogMutationResult = NonNullable<Awaited<ReturnType<typeof createMembershipFromCatalog>>>
    export type CreateMembershipFromCatalogMutationBody = CreateMembershipFromCatalogRequest
    export type CreateMembershipFromCatalogMutationError = ErrorType<unknown>
    export type CreateMembershipFromCatalogMutationVariables = {platformId: string;data: CreateMembershipFromCatalogRequest}

    /**
 * @summary Creates a single draft membership from structured "basics" (name, monthly price, and optional
commitment, included services, discounts, and description) by running them through the catalog
importer's AI enrichment pipeline plus a chained generation step that resolves the included services
and discounts by name against the platform's active catalog. Intended for agent-driven flows (Fin).
Only name and monthly price are required. Returns immediately with the import id; the enriched draft
is created asynchronously. When a callback URL and conversation id are supplied, the backend POSTs a
completion notification to that URL so a paused Fin "Wait for webhook" workflow can resume.
 */
export const useCreateMembershipFromCatalog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMembershipFromCatalog>>, TError,CreateMembershipFromCatalogMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMembershipFromCatalog>>,
        TError,
        CreateMembershipFromCatalogMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMembershipFromCatalogMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves the status of a practice catalog data import.
 */
export const getPracticeCatalogDataImportStatus = (
    platformId: string,
    importId: string,
 signal?: AbortSignal
) => {


      return customAxios<PracticeCatalogDataImportStatus>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/${importId}/status`, method: 'GET', signal
    },
      );
    }




export const getGetPracticeCatalogDataImportStatusQueryKey = (platformId: string,
    importId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/catalog/import/${importId}/status`
    ] as const;
    }


export const getGetPracticeCatalogDataImportStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(platformId: string,
    importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPracticeCatalogDataImportStatusQueryKey(platformId,importId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>> = ({ signal }) => getPracticeCatalogDataImportStatus(platformId,importId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined && importId !== null && importId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPracticeCatalogDataImportStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>>
export type GetPracticeCatalogDataImportStatusQueryError = ErrorType<unknown>


export function useGetPracticeCatalogDataImportStatus<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>,
          TError,
          Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPracticeCatalogDataImportStatus<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>,
          TError,
          Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPracticeCatalogDataImportStatus<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the status of a practice catalog data import.
 */

export function useGetPracticeCatalogDataImportStatus<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPracticeCatalogDataImportStatusQueryOptions(platformId,importId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPracticeCatalogDataImportStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(platformId: string,
    importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPracticeCatalogDataImportStatusQueryKey(platformId,importId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>> = ({ signal }) => getPracticeCatalogDataImportStatus(platformId,importId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPracticeCatalogDataImportStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>>
export type GetPracticeCatalogDataImportStatusSuspenseQueryError = ErrorType<unknown>


export function useGetPracticeCatalogDataImportStatusSuspense<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPracticeCatalogDataImportStatusSuspense<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPracticeCatalogDataImportStatusSuspense<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the status of a practice catalog data import.
 */

export function useGetPracticeCatalogDataImportStatusSuspense<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPracticeCatalogDataImportStatusSuspenseQueryOptions(platformId,importId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the latest practice catalog data import for a platform.
Returns import id, status, and timestamps; all properties are null when no import exists.
 */
export const getLatestPracticeCatalogDataImport = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<LatestPracticeCatalogDataImportRetrievedResponse>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/latest`, method: 'GET', signal
    },
      );
    }




export const getGetLatestPracticeCatalogDataImportQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/catalog/import/latest`
    ] as const;
    }


export const getGetLatestPracticeCatalogDataImportQueryOptions = <TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestPracticeCatalogDataImportQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>> = ({ signal }) => getLatestPracticeCatalogDataImport(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLatestPracticeCatalogDataImportQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>>
export type GetLatestPracticeCatalogDataImportQueryError = ErrorType<unknown>


export function useGetLatestPracticeCatalogDataImport<TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>,
          TError,
          Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestPracticeCatalogDataImport<TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>,
          TError,
          Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestPracticeCatalogDataImport<TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the latest practice catalog data import for a platform.
Returns import id, status, and timestamps; all properties are null when no import exists.
 */

export function useGetLatestPracticeCatalogDataImport<TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLatestPracticeCatalogDataImportQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLatestPracticeCatalogDataImportSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestPracticeCatalogDataImportQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>> = ({ signal }) => getLatestPracticeCatalogDataImport(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLatestPracticeCatalogDataImportSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>>
export type GetLatestPracticeCatalogDataImportSuspenseQueryError = ErrorType<unknown>


export function useGetLatestPracticeCatalogDataImportSuspense<TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestPracticeCatalogDataImportSuspense<TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestPracticeCatalogDataImportSuspense<TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the latest practice catalog data import for a platform.
Returns import id, status, and timestamps; all properties are null when no import exists.
 */

export function useGetLatestPracticeCatalogDataImportSuspense<TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLatestPracticeCatalogDataImportSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the preview of a practice catalog data import.
Returns null if the import was not started or is already completed.
 */
export const getPracticeCatalogDataImportPreview = (
    platformId: string,
    importId: string,
 signal?: AbortSignal
) => {


      return customAxios<PracticeCatalogDataImportPreview>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/${importId}/preview`, method: 'GET', signal
    },
      );
    }




export const getGetPracticeCatalogDataImportPreviewQueryKey = (platformId: string,
    importId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/catalog/import/${importId}/preview`
    ] as const;
    }


export const getGetPracticeCatalogDataImportPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(platformId: string,
    importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPracticeCatalogDataImportPreviewQueryKey(platformId,importId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>> = ({ signal }) => getPracticeCatalogDataImportPreview(platformId,importId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined && importId !== null && importId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPracticeCatalogDataImportPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>>
export type GetPracticeCatalogDataImportPreviewQueryError = ErrorType<unknown>


export function useGetPracticeCatalogDataImportPreview<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>,
          TError,
          Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPracticeCatalogDataImportPreview<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>,
          TError,
          Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPracticeCatalogDataImportPreview<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the preview of a practice catalog data import.
Returns null if the import was not started or is already completed.
 */

export function useGetPracticeCatalogDataImportPreview<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPracticeCatalogDataImportPreviewQueryOptions(platformId,importId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPracticeCatalogDataImportPreviewSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(platformId: string,
    importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPracticeCatalogDataImportPreviewQueryKey(platformId,importId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>> = ({ signal }) => getPracticeCatalogDataImportPreview(platformId,importId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPracticeCatalogDataImportPreviewSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>>
export type GetPracticeCatalogDataImportPreviewSuspenseQueryError = ErrorType<unknown>


export function useGetPracticeCatalogDataImportPreviewSuspense<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPracticeCatalogDataImportPreviewSuspense<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPracticeCatalogDataImportPreviewSuspense<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the preview of a practice catalog data import.
Returns null if the import was not started or is already completed.
 */

export function useGetPracticeCatalogDataImportPreviewSuspense<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPracticeCatalogDataImportPreviewSuspenseQueryOptions(platformId,importId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Completes a practice catalog data import and cleans up temporary files.
 */
export const completePracticeCatalogDataImport = (
    platformId: string,
    importId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/${importId}/complete`, method: 'POST', signal
    },
      );
    }




export const getCompletePracticeCatalogDataImportMutationKey = () => ['completePracticeCatalogDataImport'] as const;

export const getCompletePracticeCatalogDataImportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePracticeCatalogDataImport>>, TError,CompletePracticeCatalogDataImportMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completePracticeCatalogDataImport>>, TError,CompletePracticeCatalogDataImportMutationVariables, TContext> => {

const mutationKey = getCompletePracticeCatalogDataImportMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completePracticeCatalogDataImport>>, CompletePracticeCatalogDataImportMutationVariables> = (props) => {
          const {platformId,importId} = props ?? {};

          return  completePracticeCatalogDataImport(platformId,importId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompletePracticeCatalogDataImportMutationResult = NonNullable<Awaited<ReturnType<typeof completePracticeCatalogDataImport>>>

    export type CompletePracticeCatalogDataImportMutationError = ErrorType<unknown>
    export type CompletePracticeCatalogDataImportMutationVariables = {platformId: string;importId: string}

    /**
 * @summary Completes a practice catalog data import and cleans up temporary files.
 */
export const useCompletePracticeCatalogDataImport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePracticeCatalogDataImport>>, TError,CompletePracticeCatalogDataImportMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completePracticeCatalogDataImport>>,
        TError,
        CompletePracticeCatalogDataImportMutationVariables,
        TContext
      > => {
      return useMutation(getCompletePracticeCatalogDataImportMutationOptions(options), queryClient);
    }
    /**
 * @summary Records that the user has been notified that this catalog import has finished
(e.g. dismissed the notification or opened the services page). Idempotent.
 */
export const acknowledgePracticeCatalogDataImport = (
    platformId: string,
    importId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/${importId}/acknowledge`, method: 'POST', signal
    },
      );
    }




export const getAcknowledgePracticeCatalogDataImportMutationKey = () => ['acknowledgePracticeCatalogDataImport'] as const;

export const getAcknowledgePracticeCatalogDataImportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>, TError,AcknowledgePracticeCatalogDataImportMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>, TError,AcknowledgePracticeCatalogDataImportMutationVariables, TContext> => {

const mutationKey = getAcknowledgePracticeCatalogDataImportMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>, AcknowledgePracticeCatalogDataImportMutationVariables> = (props) => {
          const {platformId,importId} = props ?? {};

          return  acknowledgePracticeCatalogDataImport(platformId,importId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcknowledgePracticeCatalogDataImportMutationResult = NonNullable<Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>>

    export type AcknowledgePracticeCatalogDataImportMutationError = ErrorType<unknown>
    export type AcknowledgePracticeCatalogDataImportMutationVariables = {platformId: string;importId: string}

    /**
 * @summary Records that the user has been notified that this catalog import has finished
(e.g. dismissed the notification or opened the services page). Idempotent.
 */
export const useAcknowledgePracticeCatalogDataImport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>, TError,AcknowledgePracticeCatalogDataImportMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>,
        TError,
        AcknowledgePracticeCatalogDataImportMutationVariables,
        TContext
      > => {
      return useMutation(getAcknowledgePracticeCatalogDataImportMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves the company verification process (KYB) status for a platform.
 */
export const getCompanyVerificationProcess = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCompanyVerificationProcess>(
      {url: `/api/v1/platforms/${platformId}/verification-process`, method: 'GET', signal
    },
      );
    }




export const getGetCompanyVerificationProcessQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/verification-process`
    ] as const;
    }


export const getGetCompanyVerificationProcessQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyVerificationProcessQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyVerificationProcess>>> = ({ signal }) => getCompanyVerificationProcess(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyVerificationProcessQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyVerificationProcess>>>
export type GetCompanyVerificationProcessQueryError = ErrorType<unknown>


export function useGetCompanyVerificationProcess<TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyVerificationProcess>>,
          TError,
          Awaited<ReturnType<typeof getCompanyVerificationProcess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyVerificationProcess<TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyVerificationProcess>>,
          TError,
          Awaited<ReturnType<typeof getCompanyVerificationProcess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyVerificationProcess<TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the company verification process (KYB) status for a platform.
 */

export function useGetCompanyVerificationProcess<TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyVerificationProcessQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCompanyVerificationProcessSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyVerificationProcessQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyVerificationProcess>>> = ({ signal }) => getCompanyVerificationProcess(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCompanyVerificationProcessSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyVerificationProcess>>>
export type GetCompanyVerificationProcessSuspenseQueryError = ErrorType<unknown>


export function useGetCompanyVerificationProcessSuspense<TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyVerificationProcessSuspense<TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyVerificationProcessSuspense<TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the company verification process (KYB) status for a platform.
 */

export function useGetCompanyVerificationProcessSuspense<TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyVerificationProcessSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves a paged list of all platforms with each platform's company KYB verification
status (null when the platform has never started verification), together with the actor who
last set that status and when, for the global admin business-verification view.
 */
export const getPagedPlatformVerificationProcesses = (
    params?: GetPagedPlatformVerificationProcessesParams,
 signal?: AbortSignal
) => {


      return customAxios<DisplayPagedPlatformVerificationProcessesResponse>(
      {url: `/api/v1/platforms/verification-processes/paged`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetPagedPlatformVerificationProcessesQueryKey = (params?: GetPagedPlatformVerificationProcessesParams,) => {
    return [
    `/api/v1/platforms/verification-processes/paged`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPagedPlatformVerificationProcessesQueryOptions = <TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(params?: GetPagedPlatformVerificationProcessesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPagedPlatformVerificationProcessesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>> = ({ signal }) => getPagedPlatformVerificationProcesses(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPagedPlatformVerificationProcessesQueryResult = NonNullable<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>>
export type GetPagedPlatformVerificationProcessesQueryError = ErrorType<unknown>


export function useGetPagedPlatformVerificationProcesses<TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPagedPlatformVerificationProcessesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>,
          TError,
          Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPagedPlatformVerificationProcesses<TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(
 params?: GetPagedPlatformVerificationProcessesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>,
          TError,
          Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPagedPlatformVerificationProcesses<TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(
 params?: GetPagedPlatformVerificationProcessesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a paged list of all platforms with each platform's company KYB verification
status (null when the platform has never started verification), together with the actor who
last set that status and when, for the global admin business-verification view.
 */

export function useGetPagedPlatformVerificationProcesses<TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(
 params?: GetPagedPlatformVerificationProcessesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPagedPlatformVerificationProcessesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPagedPlatformVerificationProcessesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(params?: GetPagedPlatformVerificationProcessesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPagedPlatformVerificationProcessesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>> = ({ signal }) => getPagedPlatformVerificationProcesses(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPagedPlatformVerificationProcessesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>>
export type GetPagedPlatformVerificationProcessesSuspenseQueryError = ErrorType<unknown>


export function useGetPagedPlatformVerificationProcessesSuspense<TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPagedPlatformVerificationProcessesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPagedPlatformVerificationProcessesSuspense<TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(
 params?: GetPagedPlatformVerificationProcessesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPagedPlatformVerificationProcessesSuspense<TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(
 params?: GetPagedPlatformVerificationProcessesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a paged list of all platforms with each platform's company KYB verification
status (null when the platform has never started verification), together with the actor who
last set that status and when, for the global admin business-verification view.
 */

export function useGetPagedPlatformVerificationProcessesSuspense<TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(
 params?: GetPagedPlatformVerificationProcessesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPagedPlatformVerificationProcessesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves company verification information for a platform.
 */
export const getCompanyVerificationInformation = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCompanyVerificationInformation>(
      {url: `/api/v1/platforms/${platformId}/verification-information`, method: 'GET', signal
    },
      );
    }




export const getGetCompanyVerificationInformationQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/verification-information`
    ] as const;
    }


export const getGetCompanyVerificationInformationQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyVerificationInformationQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyVerificationInformation>>> = ({ signal }) => getCompanyVerificationInformation(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyVerificationInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyVerificationInformation>>>
export type GetCompanyVerificationInformationQueryError = ErrorType<unknown>


export function useGetCompanyVerificationInformation<TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyVerificationInformation>>,
          TError,
          Awaited<ReturnType<typeof getCompanyVerificationInformation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyVerificationInformation<TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyVerificationInformation>>,
          TError,
          Awaited<ReturnType<typeof getCompanyVerificationInformation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyVerificationInformation<TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves company verification information for a platform.
 */

export function useGetCompanyVerificationInformation<TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyVerificationInformationQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCompanyVerificationInformationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyVerificationInformationQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyVerificationInformation>>> = ({ signal }) => getCompanyVerificationInformation(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCompanyVerificationInformationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyVerificationInformation>>>
export type GetCompanyVerificationInformationSuspenseQueryError = ErrorType<unknown>


export function useGetCompanyVerificationInformationSuspense<TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyVerificationInformationSuspense<TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyVerificationInformationSuspense<TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves company verification information for a platform.
 */

export function useGetCompanyVerificationInformationSuspense<TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyVerificationInformationSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves Persona company KYB account data for a platform.
 */
export const getCompanyKybAccounts = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCompanyKybAccountsResponse>(
      {url: `/api/v1/platforms/${platformId}/verification-accounts`, method: 'GET', signal
    },
      );
    }




export const getGetCompanyKybAccountsQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/verification-accounts`
    ] as const;
    }


export const getGetCompanyKybAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyKybAccountsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyKybAccounts>>> = ({ signal }) => getCompanyKybAccounts(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyKybAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyKybAccounts>>>
export type GetCompanyKybAccountsQueryError = ErrorType<unknown>


export function useGetCompanyKybAccounts<TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyKybAccounts>>,
          TError,
          Awaited<ReturnType<typeof getCompanyKybAccounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKybAccounts<TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyKybAccounts>>,
          TError,
          Awaited<ReturnType<typeof getCompanyKybAccounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKybAccounts<TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves Persona company KYB account data for a platform.
 */

export function useGetCompanyKybAccounts<TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyKybAccountsQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCompanyKybAccountsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyKybAccountsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyKybAccounts>>> = ({ signal }) => getCompanyKybAccounts(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCompanyKybAccountsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyKybAccounts>>>
export type GetCompanyKybAccountsSuspenseQueryError = ErrorType<unknown>


export function useGetCompanyKybAccountsSuspense<TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKybAccountsSuspense<TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKybAccountsSuspense<TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves Persona company KYB account data for a platform.
 */

export function useGetCompanyKybAccountsSuspense<TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyKybAccountsSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Re-tracks the `PersonaKybInquiryCompleted` Customer.io event for every active platform
admin with the Administrator role — the manual compensation entry point when the
webhook-driven `inquiry.completed` notification was missed or failed. There is no
dedup: every call emits a fresh track event per admin, so only run it when the
notification genuinely needs re-sending.
 */
export const notifyPlatformAdminsOfPersonaKybInquiryCompleted = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/verification-process/completed-notifications`, method: 'POST', signal
    },
      );
    }




export const getNotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationKey = () => ['notifyPlatformAdminsOfPersonaKybInquiryCompleted'] as const;

export const getNotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>, TError,NotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>, TError,NotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationVariables, TContext> => {

const mutationKey = getNotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>, NotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  notifyPlatformAdminsOfPersonaKybInquiryCompleted(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>>

    export type NotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationError = ErrorType<unknown>
    export type NotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationVariables = {platformId: string}

    /**
 * @summary Re-tracks the `PersonaKybInquiryCompleted` Customer.io event for every active platform
admin with the Administrator role — the manual compensation entry point when the
webhook-driven `inquiry.completed` notification was missed or failed. There is no
dedup: every call emits a fresh track event per admin, so only run it when the
notification genuinely needs re-sending.
 */
export const useNotifyPlatformAdminsOfPersonaKybInquiryCompleted = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>, TError,NotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>,
        TError,
        NotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationVariables,
        TContext
      > => {
      return useMutation(getNotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationOptions(options), queryClient);
    }
    /**
 * @summary Manually sets a platform's Company KYB verification status — the compensation entry point
for correcting a status stomped by an infrastructure bug (e.g. a stale webhook demoting an
Approved process). Unlike webhook-driven changes, this manual path bypasses the domain
transition guard, so it can demote an Approved process (forced de-approval). Setting the
same status remains a no-op.
 */
export const setCompanyKybVerificationStatusForPlatform = (
    platformId: string,
    setCompanyKybVerificationStatusForPlatformRequest: SetCompanyKybVerificationStatusForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCompanyKybVerificationStatusForPlatform>(
      {url: `/api/v1/platforms/${platformId}/verification-process/status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setCompanyKybVerificationStatusForPlatformRequest, signal
    },
      );
    }




export const getSetCompanyKybVerificationStatusForPlatformMutationKey = () => ['setCompanyKybVerificationStatusForPlatform'] as const;

export const getSetCompanyKybVerificationStatusForPlatformMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>, TError,SetCompanyKybVerificationStatusForPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>, TError,SetCompanyKybVerificationStatusForPlatformMutationVariables, TContext> => {

const mutationKey = getSetCompanyKybVerificationStatusForPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>, SetCompanyKybVerificationStatusForPlatformMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  setCompanyKybVerificationStatusForPlatform(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetCompanyKybVerificationStatusForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>>
    export type SetCompanyKybVerificationStatusForPlatformMutationBody = SetCompanyKybVerificationStatusForPlatformRequest
    export type SetCompanyKybVerificationStatusForPlatformMutationError = ErrorType<ProblemDetails>
    export type SetCompanyKybVerificationStatusForPlatformMutationVariables = {platformId: string;data: SetCompanyKybVerificationStatusForPlatformRequest}

    /**
 * @summary Manually sets a platform's Company KYB verification status — the compensation entry point
for correcting a status stomped by an infrastructure bug (e.g. a stale webhook demoting an
Approved process). Unlike webhook-driven changes, this manual path bypasses the domain
transition guard, so it can demote an Approved process (forced de-approval). Setting the
same status remains a no-op.
 */
export const useSetCompanyKybVerificationStatusForPlatform = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>, TError,SetCompanyKybVerificationStatusForPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>,
        TError,
        SetCompanyKybVerificationStatusForPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getSetCompanyKybVerificationStatusForPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves onboarding progress for a platform.
Returns a not-started response when the platform exists but no onboarding progress has been recorded yet.
 */
export const getPlatformOnboardingProgress = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayPlatformOnboardingProgress>(
      {url: `/api/v1/platforms/${platformId}/onboarding-progress`, method: 'GET', signal
    },
      );
    }




export const getGetPlatformOnboardingProgressQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/onboarding-progress`
    ] as const;
    }


export const getGetPlatformOnboardingProgressQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformOnboardingProgressQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>> = ({ signal }) => getPlatformOnboardingProgress(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformOnboardingProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>>
export type GetPlatformOnboardingProgressQueryError = ErrorType<void>


export function useGetPlatformOnboardingProgress<TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformOnboardingProgress>>,
          TError,
          Awaited<ReturnType<typeof getPlatformOnboardingProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformOnboardingProgress<TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformOnboardingProgress>>,
          TError,
          Awaited<ReturnType<typeof getPlatformOnboardingProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformOnboardingProgress<TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves onboarding progress for a platform.
Returns a not-started response when the platform exists but no onboarding progress has been recorded yet.
 */

export function useGetPlatformOnboardingProgress<TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformOnboardingProgressQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPlatformOnboardingProgressSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformOnboardingProgressQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>> = ({ signal }) => getPlatformOnboardingProgress(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPlatformOnboardingProgressSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>>
export type GetPlatformOnboardingProgressSuspenseQueryError = ErrorType<void>


export function useGetPlatformOnboardingProgressSuspense<TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformOnboardingProgressSuspense<TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformOnboardingProgressSuspense<TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves onboarding progress for a platform.
Returns a not-started response when the platform exists but no onboarding progress has been recorded yet.
 */

export function useGetPlatformOnboardingProgressSuspense<TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformOnboardingProgressSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Confirms onboarding user information for a platform.
Captures the currently confirmed user details even when no admin user fields changed.
 */
export const confirmOnboardingUserInformation = (
    platformId: string,
    confirmOnboardingUserInformationForPlatformRequest: ConfirmOnboardingUserInformationForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-user-information`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmOnboardingUserInformationForPlatformRequest, signal
    },
      );
    }




export const getConfirmOnboardingUserInformationMutationKey = () => ['confirmOnboardingUserInformation'] as const;

export const getConfirmOnboardingUserInformationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingUserInformation>>, TError,ConfirmOnboardingUserInformationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingUserInformation>>, TError,ConfirmOnboardingUserInformationMutationVariables, TContext> => {

const mutationKey = getConfirmOnboardingUserInformationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingUserInformation>>, ConfirmOnboardingUserInformationMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmOnboardingUserInformation(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingUserInformationMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingUserInformation>>>
    export type ConfirmOnboardingUserInformationMutationBody = ConfirmOnboardingUserInformationForPlatformRequest
    export type ConfirmOnboardingUserInformationMutationError = ErrorType<unknown>
    export type ConfirmOnboardingUserInformationMutationVariables = {platformId: string;data: ConfirmOnboardingUserInformationForPlatformRequest}

    /**
 * @summary Confirms onboarding user information for a platform.
Captures the currently confirmed user details even when no admin user fields changed.
 */
export const useConfirmOnboardingUserInformation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingUserInformation>>, TError,ConfirmOnboardingUserInformationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingUserInformation>>,
        TError,
        ConfirmOnboardingUserInformationMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmOnboardingUserInformationMutationOptions(options), queryClient);
    }
    /**
 * @summary Confirms onboarding locations for a platform.
Captures the current state of all platform locations as confirmed during onboarding.
 */
export const confirmOnboardingLocations = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-locations`, method: 'POST', signal
    },
      );
    }




export const getConfirmOnboardingLocationsMutationKey = () => ['confirmOnboardingLocations'] as const;

export const getConfirmOnboardingLocationsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingLocations>>, TError,ConfirmOnboardingLocationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingLocations>>, TError,ConfirmOnboardingLocationsMutationVariables, TContext> => {

const mutationKey = getConfirmOnboardingLocationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingLocations>>, ConfirmOnboardingLocationsMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  confirmOnboardingLocations(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingLocationsMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingLocations>>>

    export type ConfirmOnboardingLocationsMutationError = ErrorType<void>
    export type ConfirmOnboardingLocationsMutationVariables = {platformId: string}

    /**
 * @summary Confirms onboarding locations for a platform.
Captures the current state of all platform locations as confirmed during onboarding.
 */
export const useConfirmOnboardingLocations = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingLocations>>, TError,ConfirmOnboardingLocationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingLocations>>,
        TError,
        ConfirmOnboardingLocationsMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmOnboardingLocationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Completes the product-led growth onboarding flow for a platform.
 */
export const completePlgOnboarding = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/complete-plg-onboarding`, method: 'POST', signal
    },
      );
    }




export const getCompletePlgOnboardingMutationKey = () => ['completePlgOnboarding'] as const;

export const getCompletePlgOnboardingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePlgOnboarding>>, TError,CompletePlgOnboardingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completePlgOnboarding>>, TError,CompletePlgOnboardingMutationVariables, TContext> => {

const mutationKey = getCompletePlgOnboardingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completePlgOnboarding>>, CompletePlgOnboardingMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  completePlgOnboarding(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompletePlgOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof completePlgOnboarding>>>

    export type CompletePlgOnboardingMutationError = ErrorType<unknown>
    export type CompletePlgOnboardingMutationVariables = {platformId: string}

    /**
 * @summary Completes the product-led growth onboarding flow for a platform.
 */
export const useCompletePlgOnboarding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePlgOnboarding>>, TError,CompletePlgOnboardingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completePlgOnboarding>>,
        TError,
        CompletePlgOnboardingMutationVariables,
        TContext
      > => {
      return useMutation(getCompletePlgOnboardingMutationOptions(options), queryClient);
    }
    /**
 * @summary Confirms the onboarding payment step for a platform.
Records whether the payment step was completed, skipped, or is in progress.
 */
export const confirmOnboardingPaymentStep = (
    platformId: string,
    confirmOnboardingPaymentStepForPlatformRequest: ConfirmOnboardingPaymentStepForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-payment-step`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmOnboardingPaymentStepForPlatformRequest, signal
    },
      );
    }




export const getConfirmOnboardingPaymentStepMutationKey = () => ['confirmOnboardingPaymentStep'] as const;

export const getConfirmOnboardingPaymentStepMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>, TError,ConfirmOnboardingPaymentStepMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>, TError,ConfirmOnboardingPaymentStepMutationVariables, TContext> => {

const mutationKey = getConfirmOnboardingPaymentStepMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>, ConfirmOnboardingPaymentStepMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmOnboardingPaymentStep(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingPaymentStepMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>>
    export type ConfirmOnboardingPaymentStepMutationBody = ConfirmOnboardingPaymentStepForPlatformRequest
    export type ConfirmOnboardingPaymentStepMutationError = ErrorType<unknown>
    export type ConfirmOnboardingPaymentStepMutationVariables = {platformId: string;data: ConfirmOnboardingPaymentStepForPlatformRequest}

    /**
 * @summary Confirms the onboarding payment step for a platform.
Records whether the payment step was completed, skipped, or is in progress.
 */
export const useConfirmOnboardingPaymentStep = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>, TError,ConfirmOnboardingPaymentStepMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>,
        TError,
        ConfirmOnboardingPaymentStepMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmOnboardingPaymentStepMutationOptions(options), queryClient);
    }
    /**
 * @summary Confirms the onboarding catalog upload step for a platform.
Records whether the catalog upload was completed or skipped, along with the file count.
 */
export const confirmOnboardingCatalogUpload = (
    platformId: string,
    confirmOnboardingCatalogUploadForPlatformRequest: ConfirmOnboardingCatalogUploadForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-catalog-upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmOnboardingCatalogUploadForPlatformRequest, signal
    },
      );
    }




export const getConfirmOnboardingCatalogUploadMutationKey = () => ['confirmOnboardingCatalogUpload'] as const;

export const getConfirmOnboardingCatalogUploadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>, TError,ConfirmOnboardingCatalogUploadMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>, TError,ConfirmOnboardingCatalogUploadMutationVariables, TContext> => {

const mutationKey = getConfirmOnboardingCatalogUploadMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>, ConfirmOnboardingCatalogUploadMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmOnboardingCatalogUpload(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingCatalogUploadMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>>
    export type ConfirmOnboardingCatalogUploadMutationBody = ConfirmOnboardingCatalogUploadForPlatformRequest
    export type ConfirmOnboardingCatalogUploadMutationError = ErrorType<unknown>
    export type ConfirmOnboardingCatalogUploadMutationVariables = {platformId: string;data: ConfirmOnboardingCatalogUploadForPlatformRequest}

    /**
 * @summary Confirms the onboarding catalog upload step for a platform.
Records whether the catalog upload was completed or skipped, along with the file count.
 */
export const useConfirmOnboardingCatalogUpload = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>, TError,ConfirmOnboardingCatalogUploadMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>,
        TError,
        ConfirmOnboardingCatalogUploadMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmOnboardingCatalogUploadMutationOptions(options), queryClient);
    }
    /**
 * @summary Updates the platform domain for the PLG onboarding branding step.
Applies onboarding-specific authorization and completed-assessment rules
while preserving the legacy domain update side effects.
 */
export const updatePlgOnboardingBrandingDomain = (
    platformId: string,
    updatePlatformDomainRequest: UpdatePlatformDomainRequest,
 signal?: AbortSignal
) => {


      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}/plg-onboarding-branding-domain`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformDomainRequest, signal
    },
      );
    }




export const getUpdatePlgOnboardingBrandingDomainMutationKey = () => ['updatePlgOnboardingBrandingDomain'] as const;

export const getUpdatePlgOnboardingBrandingDomainMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>, TError,UpdatePlgOnboardingBrandingDomainMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>, TError,UpdatePlgOnboardingBrandingDomainMutationVariables, TContext> => {

const mutationKey = getUpdatePlgOnboardingBrandingDomainMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>, UpdatePlgOnboardingBrandingDomainMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlgOnboardingBrandingDomain(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlgOnboardingBrandingDomainMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>>
    export type UpdatePlgOnboardingBrandingDomainMutationBody = UpdatePlatformDomainRequest
    export type UpdatePlgOnboardingBrandingDomainMutationError = ErrorType<void>
    export type UpdatePlgOnboardingBrandingDomainMutationVariables = {platformId: string;data: UpdatePlatformDomainRequest}

    /**
 * @summary Updates the platform domain for the PLG onboarding branding step.
Applies onboarding-specific authorization and completed-assessment rules
while preserving the legacy domain update side effects.
 */
export const useUpdatePlgOnboardingBrandingDomain = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>, TError,UpdatePlgOnboardingBrandingDomainMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>,
        TError,
        UpdatePlgOnboardingBrandingDomainMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePlgOnboardingBrandingDomainMutationOptions(options), queryClient);
    }
    /**
 * @summary Confirms the onboarding branding step for a platform.
Records the branding details (app name, brand color, logo, domain) confirmed during onboarding.
 */
export const confirmOnboardingBranding = (
    platformId: string,
    confirmOnboardingBrandingForPlatformRequest: ConfirmOnboardingBrandingForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-branding`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmOnboardingBrandingForPlatformRequest, signal
    },
      );
    }




export const getConfirmOnboardingBrandingMutationKey = () => ['confirmOnboardingBranding'] as const;

export const getConfirmOnboardingBrandingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBranding>>, TError,ConfirmOnboardingBrandingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBranding>>, TError,ConfirmOnboardingBrandingMutationVariables, TContext> => {

const mutationKey = getConfirmOnboardingBrandingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingBranding>>, ConfirmOnboardingBrandingMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmOnboardingBranding(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingBranding>>>
    export type ConfirmOnboardingBrandingMutationBody = ConfirmOnboardingBrandingForPlatformRequest
    export type ConfirmOnboardingBrandingMutationError = ErrorType<unknown>
    export type ConfirmOnboardingBrandingMutationVariables = {platformId: string;data: ConfirmOnboardingBrandingForPlatformRequest}

    /**
 * @summary Confirms the onboarding branding step for a platform.
Records the branding details (app name, brand color, logo, domain) confirmed during onboarding.
 */
export const useConfirmOnboardingBranding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBranding>>, TError,ConfirmOnboardingBrandingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingBranding>>,
        TError,
        ConfirmOnboardingBrandingMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmOnboardingBrandingMutationOptions(options), queryClient);
    }
    /**
 * @summary Regenerates the platform's brand icons (mobile app icon and favicon) from a logo and applies them,
retaining the icons they replace so the practice can undo.
 */
export const regenerateBrandIcons = (
    platformId: string,
    regenerateBrandIconsForPlatformRequest: RegenerateBrandIconsForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/brand-icons/regenerate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: regenerateBrandIconsForPlatformRequest, signal
    },
      );
    }




export const getRegenerateBrandIconsMutationKey = () => ['regenerateBrandIcons'] as const;

export const getRegenerateBrandIconsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateBrandIcons>>, TError,RegenerateBrandIconsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regenerateBrandIcons>>, TError,RegenerateBrandIconsMutationVariables, TContext> => {

const mutationKey = getRegenerateBrandIconsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateBrandIcons>>, RegenerateBrandIconsMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  regenerateBrandIcons(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateBrandIconsMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateBrandIcons>>>
    export type RegenerateBrandIconsMutationBody = RegenerateBrandIconsForPlatformRequest
    export type RegenerateBrandIconsMutationError = ErrorType<unknown>
    export type RegenerateBrandIconsMutationVariables = {platformId: string;data: RegenerateBrandIconsForPlatformRequest}

    /**
 * @summary Regenerates the platform's brand icons (mobile app icon and favicon) from a logo and applies them,
retaining the icons they replace so the practice can undo.
 */
export const useRegenerateBrandIcons = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateBrandIcons>>, TError,RegenerateBrandIconsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateBrandIcons>>,
        TError,
        RegenerateBrandIconsMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateBrandIconsMutationOptions(options), queryClient);
    }
    /**
 * @summary Gets the platform's brand-icon generation state — the latest run's outcome and whether an
undo is available.
 */
export const getBrandIconState = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayBrandIconState>(
      {url: `/api/v1/platforms/${platformId}/brand-icons/state`, method: 'GET', signal
    },
      );
    }




export const getGetBrandIconStateQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/brand-icons/state`
    ] as const;
    }


export const getGetBrandIconStateQueryOptions = <TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandIconStateQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrandIconState>>> = ({ signal }) => getBrandIconState(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrandIconStateQueryResult = NonNullable<Awaited<ReturnType<typeof getBrandIconState>>>
export type GetBrandIconStateQueryError = ErrorType<unknown>


export function useGetBrandIconState<TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrandIconState>>,
          TError,
          Awaited<ReturnType<typeof getBrandIconState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandIconState<TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrandIconState>>,
          TError,
          Awaited<ReturnType<typeof getBrandIconState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandIconState<TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the platform's brand-icon generation state — the latest run's outcome and whether an
undo is available.
 */

export function useGetBrandIconState<TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrandIconStateQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBrandIconStateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandIconStateQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrandIconState>>> = ({ signal }) => getBrandIconState(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetBrandIconStateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBrandIconState>>>
export type GetBrandIconStateSuspenseQueryError = ErrorType<unknown>


export function useGetBrandIconStateSuspense<TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandIconStateSuspense<TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandIconStateSuspense<TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the platform's brand-icon generation state — the latest run's outcome and whether an
undo is available.
 */

export function useGetBrandIconStateSuspense<TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrandIconStateSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Undoes a brand-icon replacement by restoring the icon that was live before the most recent
generation, so a practice that dislikes a generated icon need not re-upload their previous one.
 */
export const restorePreviousBrandIcons = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/brand-icons/restore-previous`, method: 'POST', signal
    },
      );
    }




export const getRestorePreviousBrandIconsMutationKey = () => ['restorePreviousBrandIcons'] as const;

export const getRestorePreviousBrandIconsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restorePreviousBrandIcons>>, TError,RestorePreviousBrandIconsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof restorePreviousBrandIcons>>, TError,RestorePreviousBrandIconsMutationVariables, TContext> => {

const mutationKey = getRestorePreviousBrandIconsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restorePreviousBrandIcons>>, RestorePreviousBrandIconsMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  restorePreviousBrandIcons(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestorePreviousBrandIconsMutationResult = NonNullable<Awaited<ReturnType<typeof restorePreviousBrandIcons>>>

    export type RestorePreviousBrandIconsMutationError = ErrorType<void>
    export type RestorePreviousBrandIconsMutationVariables = {platformId: string}

    /**
 * @summary Undoes a brand-icon replacement by restoring the icon that was live before the most recent
generation, so a practice that dislikes a generated icon need not re-upload their previous one.
 */
export const useRestorePreviousBrandIcons = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restorePreviousBrandIcons>>, TError,RestorePreviousBrandIconsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restorePreviousBrandIcons>>,
        TError,
        RestorePreviousBrandIconsMutationVariables,
        TContext
      > => {
      return useMutation(getRestorePreviousBrandIconsMutationOptions(options), queryClient);
    }
    /**
 * @summary Confirms the onboarding business verification step for a platform.
Records whether the business verification step was skipped during onboarding.
 */
export const confirmOnboardingBusinessVerification = (
    platformId: string,
    confirmOnboardingBusinessVerificationForPlatformRequest: ConfirmOnboardingBusinessVerificationForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-business-verification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmOnboardingBusinessVerificationForPlatformRequest, signal
    },
      );
    }




export const getConfirmOnboardingBusinessVerificationMutationKey = () => ['confirmOnboardingBusinessVerification'] as const;

export const getConfirmOnboardingBusinessVerificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>, TError,ConfirmOnboardingBusinessVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>, TError,ConfirmOnboardingBusinessVerificationMutationVariables, TContext> => {

const mutationKey = getConfirmOnboardingBusinessVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>, ConfirmOnboardingBusinessVerificationMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmOnboardingBusinessVerification(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingBusinessVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>>
    export type ConfirmOnboardingBusinessVerificationMutationBody = ConfirmOnboardingBusinessVerificationForPlatformRequest
    export type ConfirmOnboardingBusinessVerificationMutationError = ErrorType<unknown>
    export type ConfirmOnboardingBusinessVerificationMutationVariables = {platformId: string;data: ConfirmOnboardingBusinessVerificationForPlatformRequest}

    /**
 * @summary Confirms the onboarding business verification step for a platform.
Records whether the business verification step was skipped during onboarding.
 */
export const useConfirmOnboardingBusinessVerification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>, TError,ConfirmOnboardingBusinessVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>,
        TError,
        ConfirmOnboardingBusinessVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmOnboardingBusinessVerificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Extracts branding information from a public website URL.
 */
export const extractBranding = (
    extractPlatformBrandingRequest: ExtractPlatformBrandingRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayExtractedPlatformBranding>(
      {url: `/api/v1/platforms/branding/extract`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: extractPlatformBrandingRequest, signal
    },
      );
    }




export const getExtractBrandingMutationKey = () => ['extractBranding'] as const;

export const getExtractBrandingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractBranding>>, TError,ExtractBrandingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof extractBranding>>, TError,ExtractBrandingMutationVariables, TContext> => {

const mutationKey = getExtractBrandingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extractBranding>>, ExtractBrandingMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  extractBranding(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtractBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof extractBranding>>>
    export type ExtractBrandingMutationBody = ExtractPlatformBrandingRequest
    export type ExtractBrandingMutationError = ErrorType<unknown>
    export type ExtractBrandingMutationVariables = {data: ExtractPlatformBrandingRequest}

    /**
 * @summary Extracts branding information from a public website URL.
 */
export const useExtractBranding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractBranding>>, TError,ExtractBrandingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof extractBranding>>,
        TError,
        ExtractBrandingMutationVariables,
        TContext
      > => {
      return useMutation(getExtractBrandingMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves an optional retention-call offer using verified platform GMV before cancellation.
 */
export const getCancellationCallOfferForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCancellationCallOffer>(
      {url: `/api/v1/platforms/${platformId}/cancellation-call-offer`, method: 'GET', signal
    },
      );
    }




export const getGetCancellationCallOfferForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/cancellation-call-offer`
    ] as const;
    }


export const getGetCancellationCallOfferForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCancellationCallOfferForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>> = ({ signal }) => getCancellationCallOfferForPlatform(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCancellationCallOfferForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>>
export type GetCancellationCallOfferForPlatformQueryError = ErrorType<unknown>


export function useGetCancellationCallOfferForPlatform<TData = Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancellationCallOfferForPlatform<TData = Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancellationCallOfferForPlatform<TData = Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves an optional retention-call offer using verified platform GMV before cancellation.
 */

export function useGetCancellationCallOfferForPlatform<TData = Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCancellationCallOfferForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCancellationCallOfferForPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCancellationCallOfferForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>> = ({ signal }) => getCancellationCallOfferForPlatform(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCancellationCallOfferForPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>>
export type GetCancellationCallOfferForPlatformSuspenseQueryError = ErrorType<unknown>


export function useGetCancellationCallOfferForPlatformSuspense<TData = Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancellationCallOfferForPlatformSuspense<TData = Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancellationCallOfferForPlatformSuspense<TData = Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves an optional retention-call offer using verified platform GMV before cancellation.
 */

export function useGetCancellationCallOfferForPlatformSuspense<TData = Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationCallOfferForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCancellationCallOfferForPlatformSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves what the cancellation flow shows the practice before it cancels: whether its Company can claim the
free month, its most compelling numbers (scored and selected, best first) and its feature usage (biggest
opportunity first). Numbers are keys and values only; the Admin frontend words them.
 */
export const getCancellationContextForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayCancellationContext>(
      {url: `/api/v1/platforms/${platformId}/cancellation-context`, method: 'GET', signal
    },
      );
    }




export const getGetCancellationContextForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/cancellation-context`
    ] as const;
    }


export const getGetCancellationContextForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCancellationContextForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCancellationContextForPlatform>>> = ({ signal }) => getCancellationContextForPlatform(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCancellationContextForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getCancellationContextForPlatform>>>
export type GetCancellationContextForPlatformQueryError = ErrorType<void>


export function useGetCancellationContextForPlatform<TData = Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCancellationContextForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getCancellationContextForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancellationContextForPlatform<TData = Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCancellationContextForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getCancellationContextForPlatform>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancellationContextForPlatform<TData = Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves what the cancellation flow shows the practice before it cancels: whether its Company can claim the
free month, its most compelling numbers (scored and selected, best first) and its feature usage (biggest
opportunity first). Numbers are keys and values only; the Admin frontend words them.
 */

export function useGetCancellationContextForPlatform<TData = Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCancellationContextForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCancellationContextForPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError = ErrorType<void>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCancellationContextForPlatformQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCancellationContextForPlatform>>> = ({ signal }) => getCancellationContextForPlatform(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCancellationContextForPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCancellationContextForPlatform>>>
export type GetCancellationContextForPlatformSuspenseQueryError = ErrorType<void>


export function useGetCancellationContextForPlatformSuspense<TData = Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError = ErrorType<void>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancellationContextForPlatformSuspense<TData = Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancellationContextForPlatformSuspense<TData = Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves what the cancellation flow shows the practice before it cancels: whether its Company can claim the
free month, its most compelling numbers (scored and selected, best first) and its feature usage (biggest
opportunity first). Numbers are keys and values only; the Admin frontend words them.
 */

export function useGetCancellationContextForPlatformSuspense<TData = Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancellationContextForPlatform>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCancellationContextForPlatformSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Submits a subscription cancellation request for the specified Platform.
Creates or updates a Salesforce Case of type "Cancellation Request".
 */
export const submitCancellationRequest = (
    platformId: string,
    submitCancellationRequestBody: SubmitCancellationRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/cancellation-request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitCancellationRequestBody, signal
    },
      );
    }




export const getSubmitCancellationRequestMutationKey = () => ['submitCancellationRequest'] as const;

export const getSubmitCancellationRequestMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCancellationRequest>>, TError,SubmitCancellationRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitCancellationRequest>>, TError,SubmitCancellationRequestMutationVariables, TContext> => {

const mutationKey = getSubmitCancellationRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitCancellationRequest>>, SubmitCancellationRequestMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  submitCancellationRequest(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitCancellationRequestMutationResult = NonNullable<Awaited<ReturnType<typeof submitCancellationRequest>>>
    export type SubmitCancellationRequestMutationBody = SubmitCancellationRequest
    export type SubmitCancellationRequestMutationError = ErrorType<ProblemDetails>
    export type SubmitCancellationRequestMutationVariables = {platformId: string;data: SubmitCancellationRequest}

    /**
 * @summary Submits a subscription cancellation request for the specified Platform.
Creates or updates a Salesforce Case of type "Cancellation Request".
 */
export const useSubmitCancellationRequest = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCancellationRequest>>, TError,SubmitCancellationRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitCancellationRequest>>,
        TError,
        SubmitCancellationRequestMutationVariables,
        TContext
      > => {
      return useMutation(getSubmitCancellationRequestMutationOptions(options), queryClient);
    }
    /**
 * @summary Undoes a previously submitted subscription cancellation request by closing
the open Salesforce Case for the specified Platform.
 */
export const undoCancellationRequest = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/cancellation-request`, method: 'DELETE', signal
    },
      );
    }




export const getUndoCancellationRequestMutationKey = () => ['undoCancellationRequest'] as const;

export const getUndoCancellationRequestMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoCancellationRequest>>, TError,UndoCancellationRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof undoCancellationRequest>>, TError,UndoCancellationRequestMutationVariables, TContext> => {

const mutationKey = getUndoCancellationRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof undoCancellationRequest>>, UndoCancellationRequestMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  undoCancellationRequest(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UndoCancellationRequestMutationResult = NonNullable<Awaited<ReturnType<typeof undoCancellationRequest>>>

    export type UndoCancellationRequestMutationError = ErrorType<ProblemDetails>
    export type UndoCancellationRequestMutationVariables = {platformId: string}

    /**
 * @summary Undoes a previously submitted subscription cancellation request by closing
the open Salesforce Case for the specified Platform.
 */
export const useUndoCancellationRequest = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoCancellationRequest>>, TError,UndoCancellationRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof undoCancellationRequest>>,
        TError,
        UndoCancellationRequestMutationVariables,
        TContext
      > => {
      return useMutation(getUndoCancellationRequestMutationOptions(options), queryClient);
    }
    /**
 * @summary Records that a practice has opted for a free month and Back-On-Track playbook
instead of cancelling their subscription.
 */
export const claimSecondChance = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/second-chance-claim`, method: 'POST', signal
    },
      );
    }




export const getClaimSecondChanceMutationKey = () => ['claimSecondChance'] as const;

export const getClaimSecondChanceMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimSecondChance>>, TError,ClaimSecondChanceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof claimSecondChance>>, TError,ClaimSecondChanceMutationVariables, TContext> => {

const mutationKey = getClaimSecondChanceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimSecondChance>>, ClaimSecondChanceMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  claimSecondChance(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClaimSecondChanceMutationResult = NonNullable<Awaited<ReturnType<typeof claimSecondChance>>>

    export type ClaimSecondChanceMutationError = ErrorType<ProblemDetails>
    export type ClaimSecondChanceMutationVariables = {platformId: string}

    /**
 * @summary Records that a practice has opted for a free month and Back-On-Track playbook
instead of cancelling their subscription.
 */
export const useClaimSecondChance = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimSecondChance>>, TError,ClaimSecondChanceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof claimSecondChance>>,
        TError,
        ClaimSecondChanceMutationVariables,
        TContext
      > => {
      return useMutation(getClaimSecondChanceMutationOptions(options), queryClient);
    }
    /**
 * @summary Rates the experience after a subscription cancellation request. Writes only the supplied
exit-survey ratings and feedback onto the Platform's open Salesforce cancellation Case,
leaving its status and every other field unchanged.
 */
export const submitCancellationRatings = (
    platformId: string,
    submitCancellationRatingsRequest: SubmitCancellationRatingsRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/cancellation-ratings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitCancellationRatingsRequest, signal
    },
      );
    }




export const getSubmitCancellationRatingsMutationKey = () => ['submitCancellationRatings'] as const;

export const getSubmitCancellationRatingsMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCancellationRatings>>, TError,SubmitCancellationRatingsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitCancellationRatings>>, TError,SubmitCancellationRatingsMutationVariables, TContext> => {

const mutationKey = getSubmitCancellationRatingsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitCancellationRatings>>, SubmitCancellationRatingsMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  submitCancellationRatings(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitCancellationRatingsMutationResult = NonNullable<Awaited<ReturnType<typeof submitCancellationRatings>>>
    export type SubmitCancellationRatingsMutationBody = SubmitCancellationRatingsRequest
    export type SubmitCancellationRatingsMutationError = ErrorType<ProblemDetails>
    export type SubmitCancellationRatingsMutationVariables = {platformId: string;data: SubmitCancellationRatingsRequest}

    /**
 * @summary Rates the experience after a subscription cancellation request. Writes only the supplied
exit-survey ratings and feedback onto the Platform's open Salesforce cancellation Case,
leaving its status and every other field unchanged.
 */
export const useSubmitCancellationRatings = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCancellationRatings>>, TError,SubmitCancellationRatingsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitCancellationRatings>>,
        TError,
        SubmitCancellationRatingsMutationVariables,
        TContext
      > => {
      return useMutation(getSubmitCancellationRatingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Sends a subscription cancellation request to the RepeatMD support inbox by email, for
Platforms with no Salesforce account link. Writes nothing to Salesforce.
 */
export const submitCancellationSupportRequest = (
    platformId: string,
    submitCancellationSupportRequestRequest: SubmitCancellationSupportRequestRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/cancellation-support-request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitCancellationSupportRequestRequest, signal
    },
      );
    }




export const getSubmitCancellationSupportRequestMutationKey = () => ['submitCancellationSupportRequest'] as const;

export const getSubmitCancellationSupportRequestMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCancellationSupportRequest>>, TError,SubmitCancellationSupportRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitCancellationSupportRequest>>, TError,SubmitCancellationSupportRequestMutationVariables, TContext> => {

const mutationKey = getSubmitCancellationSupportRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitCancellationSupportRequest>>, SubmitCancellationSupportRequestMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  submitCancellationSupportRequest(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitCancellationSupportRequestMutationResult = NonNullable<Awaited<ReturnType<typeof submitCancellationSupportRequest>>>
    export type SubmitCancellationSupportRequestMutationBody = SubmitCancellationSupportRequestRequest
    export type SubmitCancellationSupportRequestMutationError = ErrorType<ProblemDetails>
    export type SubmitCancellationSupportRequestMutationVariables = {platformId: string;data: SubmitCancellationSupportRequestRequest}

    /**
 * @summary Sends a subscription cancellation request to the RepeatMD support inbox by email, for
Platforms with no Salesforce account link. Writes nothing to Salesforce.
 */
export const useSubmitCancellationSupportRequest = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCancellationSupportRequest>>, TError,SubmitCancellationSupportRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitCancellationSupportRequest>>,
        TError,
        SubmitCancellationSupportRequestMutationVariables,
        TContext
      > => {
      return useMutation(getSubmitCancellationSupportRequestMutationOptions(options), queryClient);
    }
    /**
 * @summary Opens a pending executive cancellation review once a practice in Phil's or Tommy's gated call tier has booked
the executive call: such a practice cannot submit its own cancellation request. The gate and host are
recomputed from the call-offer routing. Idempotent while a review is pending.
 */
export const defineExecutiveCancellationReview = (
    platformId: string,
    defineExecutiveCancellationReviewRequest: DefineExecutiveCancellationReviewRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/executive-cancellation-review`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: defineExecutiveCancellationReviewRequest, signal
    },
      );
    }




export const getDefineExecutiveCancellationReviewMutationKey = () => ['defineExecutiveCancellationReview'] as const;

export const getDefineExecutiveCancellationReviewMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof defineExecutiveCancellationReview>>, TError,DefineExecutiveCancellationReviewMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof defineExecutiveCancellationReview>>, TError,DefineExecutiveCancellationReviewMutationVariables, TContext> => {

const mutationKey = getDefineExecutiveCancellationReviewMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof defineExecutiveCancellationReview>>, DefineExecutiveCancellationReviewMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  defineExecutiveCancellationReview(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DefineExecutiveCancellationReviewMutationResult = NonNullable<Awaited<ReturnType<typeof defineExecutiveCancellationReview>>>
    export type DefineExecutiveCancellationReviewMutationBody = DefineExecutiveCancellationReviewRequest
    export type DefineExecutiveCancellationReviewMutationError = ErrorType<ProblemDetails>
    export type DefineExecutiveCancellationReviewMutationVariables = {platformId: string;data: DefineExecutiveCancellationReviewRequest}

    /**
 * @summary Opens a pending executive cancellation review once a practice in Phil's or Tommy's gated call tier has booked
the executive call: such a practice cannot submit its own cancellation request. The gate and host are
recomputed from the call-offer routing. Idempotent while a review is pending.
 */
export const useDefineExecutiveCancellationReview = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof defineExecutiveCancellationReview>>, TError,DefineExecutiveCancellationReviewMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof defineExecutiveCancellationReview>>,
        TError,
        DefineExecutiveCancellationReviewMutationVariables,
        TContext
      > => {
      return useMutation(getDefineExecutiveCancellationReviewMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves the platform's pending executive cancellation review, its five most recently closed reviews, and the
dates a cancellation of each type would carry if submitted today. RepeatMD staff only.
 */
export const getExecutiveCancellationReviews = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayExecutiveCancellationReviews>(
      {url: `/api/v1/platforms/${platformId}/executive-cancellation-review`, method: 'GET', signal
    },
      );
    }




export const getGetExecutiveCancellationReviewsQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/executive-cancellation-review`
    ] as const;
    }


export const getGetExecutiveCancellationReviewsQueryOptions = <TData = Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExecutiveCancellationReviewsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>> = ({ signal }) => getExecutiveCancellationReviews(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExecutiveCancellationReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>>
export type GetExecutiveCancellationReviewsQueryError = ErrorType<unknown>


export function useGetExecutiveCancellationReviews<TData = Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecutiveCancellationReviews>>,
          TError,
          Awaited<ReturnType<typeof getExecutiveCancellationReviews>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutiveCancellationReviews<TData = Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecutiveCancellationReviews>>,
          TError,
          Awaited<ReturnType<typeof getExecutiveCancellationReviews>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutiveCancellationReviews<TData = Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the platform's pending executive cancellation review, its five most recently closed reviews, and the
dates a cancellation of each type would carry if submitted today. RepeatMD staff only.
 */

export function useGetExecutiveCancellationReviews<TData = Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExecutiveCancellationReviewsQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetExecutiveCancellationReviewsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExecutiveCancellationReviewsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>> = ({ signal }) => getExecutiveCancellationReviews(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetExecutiveCancellationReviewsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>>
export type GetExecutiveCancellationReviewsSuspenseQueryError = ErrorType<unknown>


export function useGetExecutiveCancellationReviewsSuspense<TData = Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutiveCancellationReviewsSuspense<TData = Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutiveCancellationReviewsSuspense<TData = Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the platform's pending executive cancellation review, its five most recently closed reviews, and the
dates a cancellation of each type would carry if submitted today. RepeatMD staff only.
 */

export function useGetExecutiveCancellationReviewsSuspense<TData = Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutiveCancellationReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExecutiveCancellationReviewsSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the practice's pending executive cancellation review: its host and the booked call time. The
requester and the reason the practice gave are not included.
 */
export const getPendingExecutiveCancellationReview = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayPendingExecutiveCancellationReview>(
      {url: `/api/v1/platforms/${platformId}/executive-cancellation-review/pending`, method: 'GET', signal
    },
      );
    }




export const getGetPendingExecutiveCancellationReviewQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/executive-cancellation-review/pending`
    ] as const;
    }


export const getGetPendingExecutiveCancellationReviewQueryOptions = <TData = Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingExecutiveCancellationReviewQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>> = ({ signal }) => getPendingExecutiveCancellationReview(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingExecutiveCancellationReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>>
export type GetPendingExecutiveCancellationReviewQueryError = ErrorType<unknown>


export function useGetPendingExecutiveCancellationReview<TData = Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>,
          TError,
          Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingExecutiveCancellationReview<TData = Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>,
          TError,
          Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingExecutiveCancellationReview<TData = Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the practice's pending executive cancellation review: its host and the booked call time. The
requester and the reason the practice gave are not included.
 */

export function useGetPendingExecutiveCancellationReview<TData = Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingExecutiveCancellationReviewQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPendingExecutiveCancellationReviewSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingExecutiveCancellationReviewQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>> = ({ signal }) => getPendingExecutiveCancellationReview(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPendingExecutiveCancellationReviewSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>>
export type GetPendingExecutiveCancellationReviewSuspenseQueryError = ErrorType<unknown>


export function useGetPendingExecutiveCancellationReviewSuspense<TData = Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingExecutiveCancellationReviewSuspense<TData = Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingExecutiveCancellationReviewSuspense<TData = Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the practice's pending executive cancellation review: its host and the booked call time. The
requester and the reason the practice gave are not included.
 */

export function useGetPendingExecutiveCancellationReviewSuspense<TData = Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPendingExecutiveCancellationReview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingExecutiveCancellationReviewSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Records the time a practice in Phil's or Tommy's gated call tier moved its booked executive call to. Nothing is
written to Salesforce.
 */
export const setExecutiveCancellationReviewMeeting = (
    platformId: string,
    setExecutiveCancellationReviewMeetingRequest: SetExecutiveCancellationReviewMeetingRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/executive-cancellation-review/meeting`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setExecutiveCancellationReviewMeetingRequest, signal
    },
      );
    }




export const getSetExecutiveCancellationReviewMeetingMutationKey = () => ['setExecutiveCancellationReviewMeeting'] as const;

export const getSetExecutiveCancellationReviewMeetingMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setExecutiveCancellationReviewMeeting>>, TError,SetExecutiveCancellationReviewMeetingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setExecutiveCancellationReviewMeeting>>, TError,SetExecutiveCancellationReviewMeetingMutationVariables, TContext> => {

const mutationKey = getSetExecutiveCancellationReviewMeetingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setExecutiveCancellationReviewMeeting>>, SetExecutiveCancellationReviewMeetingMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  setExecutiveCancellationReviewMeeting(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetExecutiveCancellationReviewMeetingMutationResult = NonNullable<Awaited<ReturnType<typeof setExecutiveCancellationReviewMeeting>>>
    export type SetExecutiveCancellationReviewMeetingMutationBody = SetExecutiveCancellationReviewMeetingRequest
    export type SetExecutiveCancellationReviewMeetingMutationError = ErrorType<ProblemDetails>
    export type SetExecutiveCancellationReviewMeetingMutationVariables = {platformId: string;data: SetExecutiveCancellationReviewMeetingRequest}

    /**
 * @summary Records the time a practice in Phil's or Tommy's gated call tier moved its booked executive call to. Nothing is
written to Salesforce.
 */
export const useSetExecutiveCancellationReviewMeeting = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setExecutiveCancellationReviewMeeting>>, TError,SetExecutiveCancellationReviewMeetingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setExecutiveCancellationReviewMeeting>>,
        TError,
        SetExecutiveCancellationReviewMeetingMutationVariables,
        TContext
      > => {
      return useMutation(getSetExecutiveCancellationReviewMeetingMutationOptions(options), queryClient);
    }
    /**
 * @summary Records Phil's or Tommy's outcome for the platform's pending executive cancellation review. Cancel submits the
practice's cancellation (Salesforce case and staff emails) with the reason it gave and the chosen type; Saved
and ClearPending close the review and write nothing to Salesforce. RepeatMD staff only.
 */
export const setExecutiveCancellationReviewOutcome = (
    platformId: string,
    setExecutiveCancellationReviewOutcomeRequest: SetExecutiveCancellationReviewOutcomeRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/executive-cancellation-review/outcome`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setExecutiveCancellationReviewOutcomeRequest, signal
    },
      );
    }




export const getSetExecutiveCancellationReviewOutcomeMutationKey = () => ['setExecutiveCancellationReviewOutcome'] as const;

export const getSetExecutiveCancellationReviewOutcomeMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setExecutiveCancellationReviewOutcome>>, TError,SetExecutiveCancellationReviewOutcomeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setExecutiveCancellationReviewOutcome>>, TError,SetExecutiveCancellationReviewOutcomeMutationVariables, TContext> => {

const mutationKey = getSetExecutiveCancellationReviewOutcomeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setExecutiveCancellationReviewOutcome>>, SetExecutiveCancellationReviewOutcomeMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  setExecutiveCancellationReviewOutcome(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetExecutiveCancellationReviewOutcomeMutationResult = NonNullable<Awaited<ReturnType<typeof setExecutiveCancellationReviewOutcome>>>
    export type SetExecutiveCancellationReviewOutcomeMutationBody = SetExecutiveCancellationReviewOutcomeRequest
    export type SetExecutiveCancellationReviewOutcomeMutationError = ErrorType<ProblemDetails>
    export type SetExecutiveCancellationReviewOutcomeMutationVariables = {platformId: string;data: SetExecutiveCancellationReviewOutcomeRequest}

    /**
 * @summary Records Phil's or Tommy's outcome for the platform's pending executive cancellation review. Cancel submits the
practice's cancellation (Salesforce case and staff emails) with the reason it gave and the chosen type; Saved
and ClearPending close the review and write nothing to Salesforce. RepeatMD staff only.
 */
export const useSetExecutiveCancellationReviewOutcome = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setExecutiveCancellationReviewOutcome>>, TError,SetExecutiveCancellationReviewOutcomeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setExecutiveCancellationReviewOutcome>>,
        TError,
        SetExecutiveCancellationReviewOutcomeMutationVariables,
        TContext
      > => {
      return useMutation(getSetExecutiveCancellationReviewOutcomeMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves all sales associates for a platform.
 */
export const getSalesAssociates = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplaySalesAssociateResponse[]>(
      {url: `/api/v1/platforms/${platformId}/sales-associates`, method: 'GET', signal
    },
      );
    }




export const getGetSalesAssociatesQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/sales-associates`
    ] as const;
    }


export const getGetSalesAssociatesQueryOptions = <TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesAssociatesQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesAssociates>>> = ({ signal }) => getSalesAssociates(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSalesAssociatesQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesAssociates>>>
export type GetSalesAssociatesQueryError = ErrorType<unknown>


export function useGetSalesAssociates<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesAssociates>>,
          TError,
          Awaited<ReturnType<typeof getSalesAssociates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesAssociates<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesAssociates>>,
          TError,
          Awaited<ReturnType<typeof getSalesAssociates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesAssociates<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all sales associates for a platform.
 */

export function useGetSalesAssociates<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSalesAssociatesQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSalesAssociatesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesAssociatesQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesAssociates>>> = ({ signal }) => getSalesAssociates(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSalesAssociatesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesAssociates>>>
export type GetSalesAssociatesSuspenseQueryError = ErrorType<unknown>


export function useGetSalesAssociatesSuspense<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesAssociatesSuspense<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesAssociatesSuspense<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all sales associates for a platform.
 */

export function useGetSalesAssociatesSuspense<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSalesAssociatesSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Creates a new sales associate for a platform.
 */
export const createSalesAssociate = (
    platformId: string,
    createSalesAssociateRequest: CreateSalesAssociateRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplaySalesAssociateResponse>(
      {url: `/api/v1/platforms/${platformId}/sales-associates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSalesAssociateRequest, signal
    },
      );
    }




export const getCreateSalesAssociateMutationKey = () => ['createSalesAssociate'] as const;

export const getCreateSalesAssociateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalesAssociate>>, TError,CreateSalesAssociateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSalesAssociate>>, TError,CreateSalesAssociateMutationVariables, TContext> => {

const mutationKey = getCreateSalesAssociateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSalesAssociate>>, CreateSalesAssociateMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  createSalesAssociate(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSalesAssociateMutationResult = NonNullable<Awaited<ReturnType<typeof createSalesAssociate>>>
    export type CreateSalesAssociateMutationBody = CreateSalesAssociateRequest
    export type CreateSalesAssociateMutationError = ErrorType<unknown>
    export type CreateSalesAssociateMutationVariables = {platformId: string;data: CreateSalesAssociateRequest}

    /**
 * @summary Creates a new sales associate for a platform.
 */
export const useCreateSalesAssociate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalesAssociate>>, TError,CreateSalesAssociateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSalesAssociate>>,
        TError,
        CreateSalesAssociateMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSalesAssociateMutationOptions(options), queryClient);
    }
    /**
 * @summary Updates an existing sales associate.
 */
export const updateSalesAssociate = (
    platformId: string,
    salesAssociateId: string,
    updateSalesAssociateRequest: UpdateSalesAssociateRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplaySalesAssociateResponse>(
      {url: `/api/v1/platforms/${platformId}/sales-associates/${salesAssociateId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSalesAssociateRequest, signal
    },
      );
    }




export const getUpdateSalesAssociateMutationKey = () => ['updateSalesAssociate'] as const;

export const getUpdateSalesAssociateMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalesAssociate>>, TError,UpdateSalesAssociateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSalesAssociate>>, TError,UpdateSalesAssociateMutationVariables, TContext> => {

const mutationKey = getUpdateSalesAssociateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSalesAssociate>>, UpdateSalesAssociateMutationVariables> = (props) => {
          const {platformId,salesAssociateId,data} = props ?? {};

          return  updateSalesAssociate(platformId,salesAssociateId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSalesAssociateMutationResult = NonNullable<Awaited<ReturnType<typeof updateSalesAssociate>>>
    export type UpdateSalesAssociateMutationBody = UpdateSalesAssociateRequest
    export type UpdateSalesAssociateMutationError = ErrorType<ProblemDetails>
    export type UpdateSalesAssociateMutationVariables = {platformId: string;salesAssociateId: string;data: UpdateSalesAssociateRequest}

    /**
 * @summary Updates an existing sales associate.
 */
export const useUpdateSalesAssociate = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalesAssociate>>, TError,UpdateSalesAssociateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSalesAssociate>>,
        TError,
        UpdateSalesAssociateMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateSalesAssociateMutationOptions(options), queryClient);
    }
